(function () {
  'use strict';

  var SESSION_PREFIX = 'duxbuxKitBuilder:v3:';
  var PREVIEW_SESSION_PREFIX = 'duxbuxKitBuilder:preview:v3:';
  var PENDING_ADD_KEY = 'duxbuxKitBuilder:pendingAdd:v1';
  var SOURCE = 'builder';
  var SEARCH_DELAY = 320;
  var SEARCH_MAX_LENGTH = 80;
  var KIT_ID_MAX_LENGTH = 64;
  var TRANSACTION_TIMEOUT = 15000;
  var PRODUCT_IMAGE_SIZES = [
    '(max-width: 359px) calc(100vw - 32px)',
    '(max-width: 599px) calc((100vw - 44px) / 2)',
    '(max-width: 768px) calc((100vw - 68px) / 3)',
    '(max-width: 1023px) calc((100vw - 64px) / 3)',
    '(max-width: 1199px) calc((100vw - 430px) / 2)',
    '260px'
  ].join(', ');
  var CART_CONFIRMATION_ATTEMPTS = 4;
  var CART_CONFIRMATION_DELAY = 1800;
  var PENDING_ADD_MAX_AGE = 120000;
  var PENDING_RECHECK_DELAY = 5000;
  var DEFAULT_SORT = 'smart';
  var SORT_VALUES = ['smart', 'best-selling', 'newest', 'price-asc', 'price-desc'];
  var LEGACY_SORT_ALIASES = {
    recommended: DEFAULT_SORT,
    'title-asc': DEFAULT_SORT
  };
  var CATEGORY_ORDER = [
    'T-Shirts',
    'Hoodies & Sweatshirts',
    'Shirts & Base Layers',
    'Jackets & Vests',
    'Pants & Shorts',
    'Headwear',
    'Cold Weather Accessories',
    'Bags & Packs',
    'Calls & Lanyards',
    'Broadheads',
    'Gun Slings',
    'Gun Cases',
    'Pet Gear',
    'Drinkware',
    'Stickers'
  ];
  var COLOR_FAMILY_ORDER = [
    'black',
    'gray',
    'white-cream',
    'brown-tan',
    'green-olive',
    'blue-navy',
    'red-maroon',
    'orange-blaze',
    'yellow-gold',
    'pink-purple',
    'camo',
    'multicolor'
  ];
  var COLOR_FAMILY_LABELS = {
    black: 'Black',
    gray: 'Gray',
    'white-cream': 'White & Cream',
    'brown-tan': 'Brown & Tan',
    'green-olive': 'Green & Olive',
    'blue-navy': 'Blue & Navy',
    'red-maroon': 'Red & Maroon',
    'orange-blaze': 'Orange & Blaze',
    'yellow-gold': 'Yellow & Gold',
    'pink-purple': 'Pink & Purple',
    camo: 'Camo',
    multicolor: 'Multicolor'
  };

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function normalizeGid(value) {
    if (value === null || value === undefined) return '';
    return String(value);
  }

  function numericId(value) {
    return normalizeGid(value).split('/').pop();
  }

  function normalizeBrand(value) {
    var brand = String(value || 'shared').toLowerCase();
    return ['dux', 'bux', 'shared'].includes(brand) ? brand : 'shared';
  }

  function normalizeSort(value) {
    var requested = String(value || '').trim();
    requested = LEGACY_SORT_ALIASES[requested] || requested;
    return SORT_VALUES.includes(requested) ? requested : DEFAULT_SORT;
  }

  function normalizeSearchValue(value) {
    return String(value || '').trim().slice(0, SEARCH_MAX_LENGTH);
  }

  function canonicalColorFamily(value) {
    var family = String(value || '').trim().toLowerCase().replace(/[_\s]+/g, '-');
    return COLOR_FAMILY_ORDER.includes(family) ? family : '';
  }

  function normalizeColorFamilies(values) {
    var seen = new Set();
    var source = Array.isArray(values) ? values : [values];

    source.forEach(function (value) {
      String(value || '').split(',').forEach(function (entry) {
        var family = canonicalColorFamily(entry);
        if (family) seen.add(family);
      });
    });

    return COLOR_FAMILY_ORDER.filter(function (family) {
      return seen.has(family);
    });
  }

  function colorFamiliesFromParams(params, key) {
    return normalizeColorFamilies(params.getAll(key));
  }

  function normalizeColorFacets(facets) {
    var seen = new Set();

    return (Array.isArray(facets) ? facets : []).map(function (facet) {
      var source = facet && typeof facet === 'object' ? facet : {};
      var fallback = typeof facet === 'string' ? facet : '';
      var value = canonicalColorFamily(source.value || fallback);
      var rawCount = source.productCount !== undefined
        ? source.productCount
        : source.availableCount !== undefined
          ? source.availableCount
          : source.count;
      var count = Number(rawCount);
      if (!value || seen.has(value)) return null;
      seen.add(value);

      return {
        value: value,
        label: String(source.label || COLOR_FAMILY_LABELS[value]).trim(),
        count: Number.isInteger(count) && count >= 0 ? count : null,
        available: source.available !== false && !(Number.isInteger(count) && count === 0),
        soldOut: source.soldOut === true
      };
    }).filter(Boolean);
  }

  function createApprovalBoundKitId(approvalVersion) {
    var approval = String(approvalVersion || '').trim();
    var prefix = approval + '.';
    var suffixLength = KIT_ID_MAX_LENGTH - prefix.length;

    if (!approval || suffixLength < 12) {
      throw new Error('The current kit approval is invalid. Refresh and try again.');
    }

    var randomSuffix = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID().replace(/-/g, '')
      : Date.now().toString(36) + Math.random().toString(36).slice(2);

    return prefix + randomSuffix.slice(0, suffixLength);
  }

  function normalizeSmartPinnedProducts(values) {
    var seen = new Set();
    if (!Array.isArray(values)) return [];

    return values.map(function (value) {
      return String(value || '').trim().toLowerCase();
    }).filter(function (handle) {
      if (!handle || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle) || seen.has(handle)) {
        return false;
      }
      seen.add(handle);
      return true;
    }).slice(0, 12);
  }

  function normalizeRuleKey(value, fallback) {
    var key = String(value || '').trim();
    return key || String(fallback || '').trim();
  }

  function normalizeTierRole(value) {
    var role = String(value || '').trim().toLowerCase().replace(/[_\s]+/g, '-');
    return role === 'core' ? 'core' : 'addon';
  }

  function compareRuleKeys(left, right) {
    left = String(left || '');
    right = String(right || '');
    if (left === right) return 0;
    return left < right ? -1 : 1;
  }

  function normalizeCategoryValue(value) {
    return String(value || '').trim().toLocaleLowerCase('en-US');
  }

  function amountToCents(value) {
    return Math.max(0, Math.round(toNumber(value, 0) * 100));
  }

  function discountedTotalCents(subtotalCents, percent) {
    return Math.round(
      Math.max(0, toNumber(subtotalCents, 0)) *
      (100 - Math.max(0, toNumber(percent, 0))) /
      100
    );
  }

  // Shopify applies the kit Function's percentage to each unit and rounds that
  // unit's discount down to the cent, so the cart can sit a few cents above a
  // whole-subtotal estimate. Mirror it for the displayed total only; the
  // marginal-value guard keeps the server's whole-subtotal arithmetic.
  function cartDiscountedTotalCents(lines, percent) {
    var rate = Math.max(0, toNumber(percent, 0));
    return lines.reduce(function (total, line) {
      var unitCents = amountToCents(line && line.price && line.price.amount);
      var quantity = Math.max(0, toNumber(line && line.quantity, 0));
      var unitDiscountCents = Math.floor(unitCents * rate / 100 + 1e-9);
      return total + (unitCents - unitDiscountCents) * quantity;
    }, 0);
  }

  function normalizePrice(value, currencyCode) {
    var source = value && typeof value === 'object' ? value : {};
    var amount = toNumber(source.amount !== undefined ? source.amount : value, 0);

    return {
      amount: Math.max(0, amount),
      currencyCode: source.currencyCode || currencyCode || 'USD'
    };
  }

  function normalizeImage(image, title) {
    if (!image) return null;
    var url = image.url || image.src || image.originalSrc;
    if (!url) return null;

    return {
      url: url,
      altText: image.altText || image.alt || title || '',
      width: Math.max(1, toNumber(image.width, 800)),
      height: Math.max(1, toNumber(image.height, 800))
    };
  }

  function shopifyImageUrl(value, width) {
    if (!value) return '';

    try {
      var url = new URL(value, window.location.origin);
      if (
        url.hostname.endsWith('cdn.shopify.com') ||
        url.hostname.endsWith('shopifycdn.com') ||
        url.hostname.endsWith('myshopify.com')
      ) {
        url.searchParams.set('width', String(width));
      }
      return url.toString();
    } catch (error) {
      return value;
    }
  }

  function applyResponsiveImage(element, image, sizes, widths) {
    if (!image || !image.url) return;

    var candidates = widths || [240, 360, 480, 640];
    element.src = shopifyImageUrl(image.url, candidates[candidates.length - 1]);
    element.srcset = candidates.map(function (width) {
      return shopifyImageUrl(image.url, width) + ' ' + width + 'w';
    }).join(', ');
    element.sizes = sizes;
    element.width = image.width;
    element.height = image.height;
  }

  function optionLabel(item) {
    if (Array.isArray(item.options) && item.options.length) {
      var values = item.options.map(function (option) {
        return option && typeof option === 'object' ? option.value : option;
      }).filter(Boolean);

      if (values.length) {
        var optionTitle = values.join(' / ');
        return /^Default Title$/i.test(optionTitle.trim()) ? 'One Size' : optionTitle;
      }
    }

    var title = item.variantTitle || item.variant_title || 'One size';
    return title === 'Default Title' ? 'One Size' : title;
  }

  function normalizeItem(item) {
    var price = normalizePrice(item.price, item.currencyCode);
    var compareAtPrice = item.compareAtPrice || item.compare_at_price;
    var productId = normalizeGid(item.productId || item.product_id || (item.product && item.product.id));
    var title = item.title || (item.product && item.product.title) || 'Approved product';
    var category = String(item.category || 'Other');
    var familyKey = normalizeRuleKey(item.familyKey || item.family_key, productId);

    return {
      productId: productId,
      variantId: normalizeGid(item.variantId || item.variant_id || item.id),
      handle: item.handle || (item.product && item.product.handle) || '',
      title: title,
      variantTitle: optionLabel(item),
      sku: item.sku || '',
      brand: normalizeBrand(item.brand),
      category: category,
      familyKey: familyKey,
      familyLabel: normalizeRuleKey(item.familyLabel || item.family_label, title),
      slotKey: normalizeRuleKey(item.slotKey || item.slot_key, category),
      tierRole: normalizeTierRole(item.tierRole || item.tier_role),
      price: price,
      compareAtPrice: compareAtPrice ? normalizePrice(compareAtPrice, price.currencyCode) : null,
      image: normalizeImage(item.image || item.featuredImage, item.title),
      available: item.available !== false,
      options: Array.isArray(item.options) ? item.options : [],
      colorFamilies: normalizeColorFamilies(item.colorFamilies || item.color_families || [])
    };
  }

  function groupItemsByProduct(items) {
    var productMap = new Map();

    items.map(normalizeItem).forEach(function (variant) {
      if (!variant.productId || !variant.variantId) return;

      if (!productMap.has(variant.productId)) {
        productMap.set(variant.productId, {
          productId: variant.productId,
          handle: variant.handle,
          title: variant.title,
          brand: variant.brand,
          category: variant.category,
          familyKey: variant.familyKey,
          familyLabel: variant.familyLabel,
          slotKey: variant.slotKey,
          tierRole: variant.tierRole,
          image: variant.image,
          variants: []
        });
      }

      var product = productMap.get(variant.productId);
      if (!product.variants.some(function (entry) { return entry.variantId === variant.variantId; })) {
        product.variants.push(variant);
      }
      if (!product.image && variant.image) product.image = variant.image;
    });

    return Array.from(productMap.values());
  }

  function productPriceCandidates(variants) {
    var source = Array.isArray(variants) ? variants : [];
    var available = source.filter(function (variant) {
      return variant && variant.available !== false;
    });
    return available.length ? available : source;
  }

  function updateKnownCategories(knownCategories, products, facets, appending) {
    if (!appending) knownCategories.clear();
    (Array.isArray(products) ? products : []).forEach(function (product) {
      if (product && product.category) knownCategories.add(String(product.category));
    });
    (Array.isArray(facets) ? facets : []).forEach(function (category) {
      var value = typeof category === 'string' ? category : category && category.value;
      if (value) knownCategories.add(String(value));
    });
    return knownCategories;
  }

  function sizeFacetGroupLabel(facet) {
    var source = facet && typeof facet === 'object' ? facet : {};
    var fallback = typeof facet === 'string' ? facet : '';
    var label = String(source.label || source.value || fallback).trim();
    var rawGroup = String(source.group || source.type || source.kind || '').trim();
    var groupClassifier = rawGroup.toLowerCase();
    var compactLabel = label.replace(/\s+/g, '');

    if (rawGroup) {
      if (/pant|short|waist|inseam|bottom|numeric/.test(groupClassifier)) {
        return 'Pants & Shorts Sizes';
      }
      if (/shirt|layer|top|alpha|hoodie|jacket|vest/.test(groupClassifier)) {
        return 'Shirt & Layer Sizes';
      }
      if (/apparel/.test(groupClassifier)) return 'Apparel Sizes';
      return rawGroup;
    }
    if (/^\d{2}(?:[x×/]\d{2})?$/.test(compactLabel)) {
      return 'Pants & Shorts Sizes';
    }
    if (/^(?:X{0,3}S|X{0,4}L|[SML]|\dX)$/i.test(compactLabel)) {
      return 'Shirt & Layer Sizes';
    }
    return 'Other Sizes';
  }

  function normalizeSizeFacets(facets) {
    var seen = new Set();

    return (Array.isArray(facets) ? facets : []).map(function (facet) {
      var source = facet && typeof facet === 'object' ? facet : {};
      var fallback = typeof facet === 'string' ? facet : '';
      var value = String(source.value || fallback).trim();
      var rawCount = source.availableCount !== undefined
        ? source.availableCount
        : source.inStockCount !== undefined
          ? source.inStockCount
          : source.productCount !== undefined
            ? source.productCount
            : source.count !== undefined
              ? source.count
              : source.totalProductCount;
      var count = Number(rawCount);
      if (!value || seen.has(value)) return null;
      seen.add(value);

      return {
        value: value,
        label: String(source.label || value).trim() || value,
        count: Number.isInteger(count) && count >= 0 ? count : null,
        group: sizeFacetGroupLabel(facet),
        available: source.available !== false && !(Number.isInteger(count) && count === 0),
        soldOut: source.soldOut === true
      };
    }).filter(Boolean);
  }

  function groupSizeFacets(facets) {
    var groups = new Map();
    normalizeSizeFacets(facets).forEach(function (facet) {
      if (!groups.has(facet.group)) groups.set(facet.group, []);
      groups.get(facet.group).push(facet);
    });

    var order = ['Apparel Sizes', 'Shirt & Layer Sizes', 'Pants & Shorts Sizes', 'Other Sizes'];
    return Array.from(groups, function (entry) {
      return { label: entry[0], options: entry[1] };
    }).sort(function (left, right) {
      var leftIndex = order.indexOf(left.label);
      var rightIndex = order.indexOf(right.label);
      if (leftIndex === -1 && rightIndex === -1) return compareRuleKeys(left.label, right.label);
      if (leftIndex === -1) return 1;
      if (rightIndex === -1) return -1;
      return leftIndex - rightIndex;
    });
  }

  function canonicalSizeValue(value) {
    var trimmed = String(value || '').trim().replace(/\s+/g, ' ');
    var compact = trimmed.toLowerCase().replace(/[^a-z0-9]+/g, '');
    var aliases = {
      xs: 'XS', xsmall: 'XS', extrasmall: 'XS',
      s: 'S', small: 'S',
      m: 'M', med: 'M', medium: 'M',
      l: 'L', large: 'L',
      xl: 'XL', '1xl': 'XL', xlarge: 'XL', extralarge: 'XL',
      xxl: '2XL', '2x': '2XL', '2xl': '2XL', '2xlarge': '2XL',
      xxxl: '3XL', '3x': '3XL', '3xl': '3XL', '3xlarge': '3XL',
      xxxxl: '4XL', '4x': '4XL', '4xl': '4XL', '4xlarge': '4XL',
      onesize: 'One Size', onesizefitsall: 'One Size', onesizeadjustable: 'One Size'
    };
    if (aliases[compact]) return aliases[compact];

    var extended = compact.match(/^([5-9])x(?:l|large)?$/);
    if (extended) return extended[1] + 'XL';
    var waist = compact.match(/^(?:w|waist)?(\d{2,3})(?:waist)?$/);
    if (waist) return waist[1];
    return trimmed;
  }

  function variantMatchesSize(variant, size) {
    var target = canonicalSizeValue(size).toLowerCase();
    if (!target || !variant || !Array.isArray(variant.options)) return false;

    return variant.options.some(function (option) {
      if (!option || typeof option !== 'object') return false;
      var optionName = String(option.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
      var isSize = optionName === 'waist' || optionName.endsWith('size');
      return isSize && canonicalSizeValue(option.value).toLowerCase() === target;
    });
  }

  function variantMatchesColors(variant, colors) {
    var selected = normalizeColorFamilies(colors);
    if (!selected.length) return true;
    if (!variant) return false;
    var variantColors = normalizeColorFamilies(variant.colorFamilies || variant.color_families || []);
    return selected.some(function (family) {
      return variantColors.includes(family);
    });
  }

  function normalizedPriceBound(value) {
    if (value === '' || value === null || value === undefined) return null;
    var bound = Number(value);
    return Number.isFinite(bound) && bound >= 0 ? bound : null;
  }

  function variantMatchesPrice(variant, minPrice, maxPrice) {
    var minimum = normalizedPriceBound(minPrice);
    var maximum = normalizedPriceBound(maxPrice);
    if (minimum === null && maximum === null) return true;
    var amount = Number(variant && variant.price && variant.price.amount);
    if (!Number.isFinite(amount) || amount < 0) return false;
    return (minimum === null || amount >= minimum) &&
      (maximum === null || amount <= maximum);
  }

  function matchingCardVariants(variants, size, colors, minPrice, maxPrice) {
    var selectedColors = normalizeColorFamilies(colors);
    return (Array.isArray(variants) ? variants : []).filter(function (variant) {
      return (!size || variantMatchesSize(variant, size)) &&
        variantMatchesColors(variant, selectedColors) &&
        variantMatchesPrice(variant, minPrice, maxPrice);
    });
  }

  function unambiguousVariantForFilters(variants, size, colors, minPrice, maxPrice) {
    var selectedColors = normalizeColorFamilies(colors);
    var minimum = normalizedPriceBound(minPrice);
    var maximum = normalizedPriceBound(maxPrice);
    if (!size && !selectedColors.length && minimum === null && maximum === null) return null;
    var matches = matchingCardVariants(
      variants,
      size,
      selectedColors,
      minimum,
      maximum
    ).filter(function (variant) {
      return variant.available;
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function unambiguousVariantForSize(variants, size) {
    if (!size) return null;
    var matches = (Array.isArray(variants) ? variants : []).filter(function (variant) {
      return variant.available && variantMatchesSize(variant, size);
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function activeTier(tiers, itemCount) {
    return tiers.reduce(function (active, tier) {
      return itemCount >= tier.units ? tier : active;
    }, { units: 0, percent: 0 });
  }

  function nextTier(tiers, itemCount) {
    return tiers.find(function (tier) {
      return tier.units > itemCount;
    }) || null;
  }

  function subtotalCents(lines) {
    return lines.reduce(function (total, line) {
      return total + amountToCents(line.price && line.price.amount) * Math.max(0, toNumber(line.quantity, 0));
    }, 0);
  }

  function familyUnitCount(lines, familyKey) {
    return lines.reduce(function (total, line) {
      var lineFamilyKey = normalizeRuleKey(line && line.familyKey, line && line.productId);
      return lineFamilyKey === familyKey
        ? total + Math.max(0, toNumber(line.quantity, 0))
        : total;
    }, 0);
  }

  function productUnitCount(lines, productId) {
    return lines.reduce(function (total, line) {
      return normalizeGid(line && line.productId) === normalizeGid(productId)
        ? total + Math.max(0, toNumber(line.quantity, 0))
        : total;
    }, 0);
  }

  function remainingItemCapacity(lines, item, limits) {
    lines = Array.isArray(lines) ? lines : [];
    limits = normalizeLimitValues(limits);
    item = item || {};

    return Math.max(0, Math.min(
      limits.maxPerProduct - productUnitCount(lines, item.productId),
      limits.maxPerFamily - familyUnitCount(
        lines,
        normalizeRuleKey(item.familyKey, item.productId)
      ),
      limits.maxUnitsPerKit - lines.reduce(function (total, line) {
        return total + Math.max(0, toNumber(line && line.quantity, 0));
      }, 0)
    ));
  }

  function tierUnitCount(lines) {
    return lines.reduce(function (total, line) {
      if (!line || normalizeTierRole(line.tierRole) !== 'core') return total;
      return total + Math.max(0, Math.floor(toNumber(line.quantity, 0)));
    }, 0);
  }

  function marginalSafePercent(lines, tiers, limits, marginalGuard) {
    var activeLines = lines.filter(function (line) {
      return line && toNumber(line.quantity, 0) > 0;
    });
    var itemCount = tierUnitCount(activeLines);
    var earnedPercent = activeTier(tiers, itemCount).percent;
    var allSubtotalCents = subtotalCents(activeLines);
    var minimumIncrementCents = Math.max(
      0,
      Math.round(toNumber(marginalGuard && marginalGuard.minimumIncrementCents, 500))
    );
    var minimumIncrementRate = Math.max(
      0,
      toNumber(marginalGuard && marginalGuard.minimumIncrementRate, 0.15)
    );
    if (minimumIncrementRate > 1) minimumIncrementRate /= 100;

    var candidates = tiers.map(function (tier) {
      return Math.max(0, toNumber(tier.percent, 0));
    }).filter(function (percent) {
      return percent > 0 && percent <= earnedPercent;
    }).filter(function (percent, index, values) {
      return values.indexOf(percent) === index;
    }).sort(function (left, right) {
      return right - left;
    });

    var safePercent = candidates.find(function (candidate) {
      var withTotalCents = discountedTotalCents(allSubtotalCents, candidate);
      return activeLines.filter(function (line) {
        return normalizeTierRole(line.tierRole) === 'core';
      }).every(function (line) {
        var withoutLines = activeLines.map(function (entry) {
          if (entry !== line) return entry;
          return Object.assign({}, entry, { quantity: Math.max(0, toNumber(entry.quantity, 0) - 1) });
        }).filter(function (entry) {
          return toNumber(entry.quantity, 0) > 0;
        });
        var earnedWithout = activeTier(tiers, tierUnitCount(withoutLines)).percent;
        var withoutPercent = Math.min(candidate, earnedWithout);
        var withoutTotalCents = discountedTotalCents(subtotalCents(withoutLines), withoutPercent);
        var incrementalCents = withTotalCents - withoutTotalCents;
        var requiredCents = Math.max(
          minimumIncrementCents,
          Math.round(amountToCents(line.price && line.price.amount) * minimumIncrementRate)
        );
        return incrementalCents >= requiredCents;
      });
    });

    safePercent = safePercent || 0;
    var totalCents = cartDiscountedTotalCents(activeLines, safePercent);
    return {
      percent: safePercent,
      earnedPercent: earnedPercent,
      subtotalCents: allSubtotalCents,
      savingsCents: allSubtotalCents - totalCents,
      totalCents: totalCents,
      tierUnitCount: itemCount
    };
  }

  function normalizeLimitValues(limits) {
    limits = limits || {};
    return {
      maxPerProduct: Math.max(1, Math.floor(toNumber(limits.maxPerProduct, 12))),
      maxPerFamily: Math.max(1, Math.floor(toNumber(
        limits.maxPerFamily !== undefined ? limits.maxPerFamily : limits.maxPerProduct,
        12
      ))),
      maxCreditsPerSlot: Math.max(1, Math.floor(toNumber(limits.maxCreditsPerSlot, 12))),
      maxUnitsPerKit: Math.max(1, Math.floor(toNumber(limits.maxUnitsPerKit, 12)))
    };
  }

  function debounce(callback, wait) {
    var timer;

    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(null, args);
      }, wait);
    };
  }

  function catalogPayloadIsValid(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return false;
    if (payload.enabled === false) return true;
    if (!Array.isArray(payload.items) || !payload.pageInfo || typeof payload.pageInfo !== 'object') {
      return false;
    }
    if (typeof payload.pageInfo.hasNextPage !== 'boolean') return false;
    if (
      payload.pageInfo.hasNextPage &&
      (typeof payload.pageInfo.endCursor !== 'string' || !payload.pageInfo.endCursor)
    ) return false;
    return true;
  }

  function pendingRecheckDelay(remaining) {
    var remainingMilliseconds = toNumber(remaining, 0);
    return remainingMilliseconds > 0
      ? Math.min(PENDING_RECHECK_DELAY, remainingMilliseconds)
      : PENDING_RECHECK_DELAY;
  }

  function expiredPendingResolution(status) {
    if (status === 'absent') {
      return {
        clearSelections: false,
        message: 'The previous cart update expired and was not found. You can submit the saved kit again.'
      };
    }
    if (status === 'partial') {
      return {
        clearSelections: true,
        message: 'Part of the previous kit is in your cart. Review your cart before rebuilding the kit.'
      };
    }
    return {
      clearSelections: true,
      message: 'The previous cart update could not be verified. Review your cart before rebuilding the kit.'
    };
  }

  function focusElement(element, options) {
    if (!element || element.isConnected === false || typeof element.focus !== 'function') return false;
    try {
      element.focus(options || {});
    } catch (error) {
      element.focus();
    }
    return true;
  }

  function safeStorageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // A private browsing policy can disable storage. The in-memory builder still works.
    }
  }

  function safeStorageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Storage is an enhancement, not a checkout dependency.
    }
  }

  async function fetchJsonWithTimeout(url, options, timeoutMessage) {
    if (typeof AbortController !== 'function') {
      var fallbackRequest = fetch(url, options).then(async function (fallbackResponse) {
        var fallbackPayload = await fallbackResponse.json().catch(function () { return {}; });
        return { response: fallbackResponse, payload: fallbackPayload };
      });
      return raceWithTimeout(fallbackRequest, timeoutMessage);
    }

    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, TRANSACTION_TIMEOUT);

    try {
      var response = await fetch(url, Object.assign({}, options, {
        signal: controller.signal
      }));
      var payload = {};
      try {
        payload = await response.json();
      } catch (error) {
        if (controller.signal.aborted) throw error;
      }
      return { response: response, payload: payload };
    } catch (error) {
      if (controller.signal.aborted) {
        var timeoutError = new Error(timeoutMessage);
        timeoutError.code = 'REQUEST_TIMEOUT';
        throw timeoutError;
      }
      throw error;
    } finally {
      window.clearTimeout(timer);
    }
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function raceWithTimeout(promise, timeoutMessage) {
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        var timeoutError = new Error(timeoutMessage);
        timeoutError.code = 'REQUEST_TIMEOUT';
        reject(timeoutError);
      }, TRANSACTION_TIMEOUT);
    });

    return Promise.race([promise, timeout]).finally(function () {
      window.clearTimeout(timer);
    });
  }

  function KitBuilder(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.catalogPath = root.dataset.catalogPath || '/apps/duxbux-kit/catalog';
    this.preflightPath = root.dataset.preflightPath || '/apps/duxbux-kit/preflight';
    this.pageSize = Math.min(50, Math.max(1, toNumber(root.dataset.pageSize, 24)));
    this.bootstrap = this.readBootstrap();
    this.smartPinnedProducts = normalizeSmartPinnedProducts(
      this.bootstrap.smartPinnedProducts
    );
    this.config = {
      enabled: this.bootstrap.enabled === true,
      previewMode: this.bootstrap.previewMode === true,
      approvalVersion: String(this.bootstrap.approvalVersion || root.dataset.approvalVersion || ''),
      rulesVersion: Math.max(1, Math.floor(toNumber(this.bootstrap.rulesVersion, 3))),
      tiers: this.normalizeTiers(this.bootstrap.tiers),
      limits: this.normalizeLimits(this.bootstrap.limits),
      marginalGuard: this.normalizeMarginalGuard(this.bootstrap.marginalGuard)
    };
    this.storagePrefix = this.config.previewMode ? PREVIEW_SESSION_PREFIX : SESSION_PREFIX;
    this.storageKey = this.storagePrefix + (this.config.approvalVersion || 'unapproved');
    this.staged = new Map();
    this.products = [];
    this.pageInfo = { hasNextPage: false, endCursor: null, totalProducts: null };
    this.sortFallbackReason = null;
    this.catalogRevision = null;
    this.catalogGeneration = 0;
    this.catalogLoading = false;
    this.catalogRetryMode = 'replace';
    this.hasLoadedMore = false;
    this.loadMoreFailed = false;
    this.abortController = null;
    this.knownCategories = new Set();
    this.selectedColors = [];
    this.isSubmitting = false;
    this.cartAddUncertain = false;
    this.activeCartAddPending = false;
    this.pendingReconcileTimer = null;
    this.lastTierUnitCount = 0;
    this.lastSafePercent = 0;
    this.currencyCode = 'USD';
    this.elements = this.collectElements();
    this.filterMediaQuery = window.matchMedia('(min-width: 769px)');
    this.summaryMediaQuery = window.matchMedia('(min-width: 1024px)');
    this.summaryCloseFocusTarget = null;
    this.summaryFallbackOpen = false;
    this.handleFilterInput = debounce(this.resetAndFetch.bind(this), SEARCH_DELAY);
  }

  KitBuilder.prototype.readBootstrap = function () {
    var element = this.root.querySelector('[data-kit-bootstrap]');
    if (!element) return {};

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return {};
    }
  };

  KitBuilder.prototype.normalizeTiers = function (tiers) {
    var fallback = [
      { units: 4, percent: 10 },
      { units: 5, percent: 15 },
      { units: 6, percent: 20 },
      { units: 7, percent: 25 }
    ];

    if (!Array.isArray(tiers) || !tiers.length) return fallback;

    return tiers.map(function (tier) {
      return {
        units: Math.max(1, toNumber(tier.units, 0)),
        percent: Math.max(0, toNumber(tier.percent, 0))
      };
    }).filter(function (tier) {
      return tier.units > 0;
    }).sort(function (a, b) {
      return a.units - b.units;
    });
  };

  KitBuilder.prototype.normalizeLimits = function (limits) {
    return normalizeLimitValues(limits);
  };

  KitBuilder.prototype.normalizeMarginalGuard = function (marginalGuard) {
    marginalGuard = marginalGuard || {};
    var rate = Math.max(0, toNumber(marginalGuard.minimumIncrementRate, 0.15));
    if (rate > 1) rate /= 100;
    return {
      minimumIncrementCents: Math.max(
        0,
        Math.round(toNumber(marginalGuard.minimumIncrementCents, 500))
      ),
      minimumIncrementRate: rate
    };
  };

  KitBuilder.prototype.collectElements = function () {
    return {
      filters: this.root.querySelector('[data-kit-filters]'),
      search: this.root.querySelector('[data-kit-search]'),
      brand: this.root.querySelector('[data-kit-brand]'),
      brandShortcuts: Array.from(this.root.querySelectorAll('[data-kit-brand-shortcut]')),
      category: this.root.querySelector('[data-kit-category]'),
      categoryQuick: this.root.querySelector('[data-kit-category-quick]'),
      categoryOptions: this.root.querySelector('[data-kit-category-options]'),
      size: this.root.querySelector('[data-kit-size]'),
      colorField: this.root.querySelector('[data-kit-color-field]'),
      colorDropdown: this.root.querySelector('[data-kit-color-dropdown]'),
      colorTrigger: this.root.querySelector('[data-kit-color-trigger]'),
      colorSummary: this.root.querySelector('[data-kit-color-summary]'),
      colorMenu: this.root.querySelector('[data-kit-color-menu]'),
      colorOptions: this.root.querySelector('[data-kit-color-options]'),
      colorAll: this.root.querySelector('[data-kit-color-all]'),
      sort: this.root.querySelector('[data-kit-sort]'),
      sortStatus: this.root.querySelector('[data-kit-sort-status]'),
      availability: this.root.querySelector('[data-kit-availability]'),
      minPrice: this.root.querySelector('[data-kit-min-price]'),
      maxPrice: this.root.querySelector('[data-kit-max-price]'),
      filterCount: this.root.querySelector('[data-kit-filter-count]'),
      filterPanel: this.root.querySelector('[data-kit-filter-panel]'),
      loading: this.root.querySelector('[data-kit-loading]'),
      disabled: this.root.querySelector('[data-kit-disabled]'),
      disabledMessage: this.root.querySelector('[data-kit-disabled-message]'),
      error: this.root.querySelector('[data-kit-error]'),
      errorMessage: this.root.querySelector('[data-kit-error-message]'),
      catalogWrap: this.root.querySelector('[data-kit-catalog-wrap]'),
      catalog: this.root.querySelector('[data-kit-catalog]'),
      resultCount: this.root.querySelector('[data-kit-result-count]'),
      empty: this.root.querySelector('[data-kit-empty]'),
      loadMoreWrap: this.root.querySelector('[data-kit-load-more-wrap]'),
      loadMore: this.root.querySelector('[data-kit-load-more]'),
      loadMoreLabel: this.root.querySelector('[data-kit-load-more-label]'),
      loadMoreCount: this.root.querySelector('[data-kit-load-more-count]'),
      mobileProgress: this.root.querySelector('[data-kit-mobile-progress]'),
      mobileCount: this.root.querySelector('[data-kit-mobile-count]'),
      mobileNext: this.root.querySelector('[data-kit-mobile-next]'),
      mobileTotal: this.root.querySelector('[data-kit-mobile-total]'),
      progressFill: this.root.querySelector(
        '[data-kit-mobile-progress] [data-kit-progress-fill]'
      ),
      openSummary: this.root.querySelector('[data-kit-open-summary]'),
      desktopSummary: this.root.querySelector('.kit-builder__summary--desktop'),
      summaryDialog: this.root.querySelector('[data-kit-summary-dialog]'),
      announcer: this.root.querySelector('[data-kit-announcer]'),
      transactionRegions: [
        this.root.querySelector('.kit-builder__shell'),
        this.root.querySelector('[data-kit-mobile-progress]'),
        this.root.querySelector('[data-kit-summary-dialog]')
      ].filter(Boolean),
      summaries: Array.from(this.root.querySelectorAll('[data-kit-summary]'))
    };
  };

  KitBuilder.prototype.init = function () {
    this.restoreFilterState();
    this.activeSort = this.elements.sort.value;
    this.updateUrlState();
    this.restoreStaged();
    this.restorePendingAdd();
    this.syncFilterPanel();
    this.bindEvents();
    this.renderSummary();
    this.setPendingSelectionState(this.cartAddUncertain);

    if (!this.config.enabled) {
      this.showDisabled('Kit products are being prepared. Check back soon.');
      return;
    }

    this.elements.mobileProgress.hidden = false;
    this.fetchCatalog({ mode: 'replace' });
    this.reconcilePendingAdd();
    this.track('kit_builder_viewed', {
      approval_version: this.config.approvalVersion
    });
  };

  KitBuilder.prototype.colorDropdownFocusable = function () {
    if (!this.elements.colorMenu) return [];
    return Array.from(this.elements.colorMenu.querySelectorAll(
      'button:not(:disabled), input[type="checkbox"]:not(:disabled)'
    )).filter(function (element) {
      return !element.hidden && !element.closest('[hidden]');
    });
  };

  KitBuilder.prototype.openColorDropdown = function (focusPosition) {
    if (!this.elements.colorMenu || !this.elements.colorTrigger) return;
    this.elements.colorMenu.hidden = false;
    this.elements.colorTrigger.setAttribute('aria-expanded', 'true');

    if (!focusPosition) return;
    var focusable = this.colorDropdownFocusable();
    var target = focusPosition === 'last'
      ? focusable[focusable.length - 1]
      : focusable[0];
    focusElement(target);
  };

  KitBuilder.prototype.closeColorDropdown = function (restoreFocus) {
    if (!this.elements.colorMenu || !this.elements.colorTrigger) return;
    this.elements.colorMenu.hidden = true;
    this.elements.colorTrigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus) focusElement(this.elements.colorTrigger, { preventScroll: true });
  };

  KitBuilder.prototype.toggleColorDropdown = function () {
    if (!this.elements.colorMenu) return;
    if (this.elements.colorMenu.hidden) {
      this.openColorDropdown();
    } else {
      this.closeColorDropdown(false);
    }
  };

  KitBuilder.prototype.handleColorDropdownKeydown = function (event) {
    var onTrigger = event.target === this.elements.colorTrigger;
    if (onTrigger && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      this.openColorDropdown(event.key === 'ArrowUp' ? 'last' : 'first');
      return;
    }

    if (event.key === 'Escape' && !this.elements.colorMenu.hidden) {
      event.preventDefault();
      this.closeColorDropdown(true);
      return;
    }

    if (onTrigger || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    var focusable = this.colorDropdownFocusable();
    var currentIndex = focusable.indexOf(event.target);
    if (currentIndex === -1 || !focusable.length) return;

    event.preventDefault();
    var nextIndex;
    if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = focusable.length - 1;
    } else if (event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % focusable.length;
    } else {
      nextIndex = (currentIndex - 1 + focusable.length) % focusable.length;
    }
    focusElement(focusable[nextIndex]);
  };

  KitBuilder.prototype.bindEvents = function () {
    var self = this;

    if (typeof this.filterMediaQuery.addEventListener === 'function') {
      this.filterMediaQuery.addEventListener('change', function () {
        self.syncFilterPanel();
      });
    } else if (typeof this.filterMediaQuery.addListener === 'function') {
      this.filterMediaQuery.addListener(function () {
        self.syncFilterPanel();
      });
    }

    if (typeof this.summaryMediaQuery.addEventListener === 'function') {
      this.summaryMediaQuery.addEventListener('change', function () {
        self.syncSummaryBreakpoint();
      });
    } else if (typeof this.summaryMediaQuery.addListener === 'function') {
      this.summaryMediaQuery.addListener(function () {
        self.syncSummaryBreakpoint();
      });
    }
    this.syncSummaryBreakpoint();

    this.elements.filters.addEventListener('submit', function (event) {
      event.preventDefault();
      self.resetAndFetch();
    });

    this.elements.search.addEventListener('input', this.handleFilterInput);
    this.elements.brand.addEventListener('change', function () {
      self.switchBrand(self.elements.brand.value, self.elements.brand);
    });
    this.elements.category.addEventListener('change', self.resetAndFetch.bind(self));
    this.elements.size.addEventListener('change', function () {
      self.resetAndFetch({ focusTarget: self.elements.size });
    });
    this.elements.colorTrigger.addEventListener('click', function () {
      self.toggleColorDropdown();
    });
    this.elements.colorDropdown.addEventListener('keydown', function (event) {
      self.handleColorDropdownKeydown(event);
    });
    document.addEventListener('focusin', function (event) {
      if (!self.elements.colorDropdown.contains(event.target)) {
        self.closeColorDropdown(false);
      }
    });
    document.addEventListener('pointerdown', function (event) {
      if (!self.elements.colorDropdown.contains(event.target)) {
        self.closeColorDropdown(false);
      }
    });
    this.elements.colorOptions.addEventListener('change', function (event) {
      if (!event.target.matches('[data-kit-color]')) return;
      var changedColor = event.target.value;
      self.selectedColors = normalizeColorFamilies(
        Array.from(self.elements.colorOptions.querySelectorAll('[data-kit-color]:checked')).map(function (input) {
          return input.value;
        })
      );
      self.syncColorControls();
      var request = self.resetAndFetch();
      if (request && typeof request.then === 'function') {
        request.then(function (result) {
          if (!result) return;
          var nextInput = self.elements.colorOptions.querySelector(
            '[data-kit-color][value="' + changedColor + '"]'
          );
          focusElement(nextInput && !nextInput.disabled ? nextInput : self.elements.colorAll);
        });
      }
    });
    this.elements.colorAll.addEventListener('click', function () {
      if (!self.selectedColors.length) return;
      self.selectedColors = [];
      self.syncColorControls();
      self.resetAndFetch({ focusTarget: self.elements.colorAll });
    });
    this.elements.brandShortcuts.forEach(function (button) {
      button.addEventListener('click', function () {
        var shortcutBrand = button.dataset.kitBrandShortcut;
        var nextBrand = self.elements.brand.value === shortcutBrand
          ? 'all'
          : shortcutBrand;
        self.switchBrand(nextBrand, button);
      });
    });
    this.elements.categoryOptions.addEventListener('click', function (event) {
      var button = event.target.closest('[data-kit-category-shortcut]');
      if (!button || self.elements.category.value === button.dataset.kitCategoryShortcut) return;
      self.elements.category.value = button.dataset.kitCategoryShortcut;
      self.syncCategoryShortcuts();
      self.resetAndFetch();
    });
    this.elements.sort.addEventListener('change', function () {
      var previousSort = self.activeSort || DEFAULT_SORT;
      var nextSort = normalizeSort(self.elements.sort.value);
      var selectedOption = self.elements.sort.options[self.elements.sort.selectedIndex];
      var nextLabel = selectedOption
        ? selectedOption.textContent.trim()
        : 'Smart Recommended';
      var filters = self.filterValues();
      self.activeSort = nextSort;
      self.track('kit_sort_changed', {
        previous_sort: previousSort,
        sort: nextSort,
        query_present: Boolean(filters.search),
        query_length: filters.search.length,
        brand: filters.brand,
        category: filters.category || 'all',
        size: filters.size || 'all',
        colors: filters.colors.length ? filters.colors : ['all']
      });

      var request = self.resetAndFetch({ focusTarget: self.elements.sort });
      if (request && typeof request.then === 'function') {
        request.then(function (result) {
          if (!result || self.elements.sort.value !== nextSort) return;
          var resultSummary = self.elements.resultCount.textContent.trim();
          if (result.sortFallbackReason === 'NO_RECENT_SALES') {
            self.announce(
              'No recent sales yet. Showing Newest' +
              (resultSummary ? '. ' + resultSummary : '.')
            );
            return;
          }
          self.announce(
            'Sorted by ' + nextLabel + (resultSummary ? '. ' + resultSummary : '.')
          );
        });
      }
    });
    [this.elements.minPrice, this.elements.maxPrice].forEach(function (element) {
      element.addEventListener('change', self.resetAndFetch.bind(self));
    });

    this.elements.filters.addEventListener('reset', function () {
      window.setTimeout(function () {
        self.elements.availability.value = 'available';
        self.elements.size.value = '';
        self.selectedColors = [];
        self.syncColorControls();
        self.elements.sort.value = DEFAULT_SORT;
        self.activeSort = DEFAULT_SORT;
        self.syncBrandShortcuts();
        self.syncCategoryShortcuts();
        self.resetAndFetch();
      }, 0);
    });

    this.root.querySelector('[data-kit-retry]').addEventListener('click', function () {
      self.retryCatalogRequest();
    });
    this.root.querySelector('[data-kit-clear-empty]').addEventListener('click', function () {
      self.elements.filters.reset();
    });

    this.elements.catalog.addEventListener('change', function (event) {
      if (!event.target.matches('[data-kit-variant-select]')) return;
      if (self.isSubmitting || self.cartAddUncertain) return;
      self.updateCardVariant(event.target.closest('[data-kit-product-card]'), event.target.value);
    });

    this.elements.catalog.addEventListener('click', function (event) {
      var button = event.target.closest('[data-kit-add]');
      if (!button) return;
      self.addFromCard(button.closest('[data-kit-product-card]'));
    });

    if (this.elements.loadMore) {
      this.elements.loadMore.addEventListener('click', function (event) {
        self.loadMoreProducts(event.detail === 0);
      });
    }

    this.root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-kit-line-action]');
      if (action) self.handleLineAction(action);
    });

    this.root.querySelectorAll('[data-kit-submit]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.submitKit();
      });
    });

    this.elements.openSummary.addEventListener('click', function () {
      self.openSummaryDialog();
    });

    this.root.querySelector('[data-kit-close-summary]').addEventListener('click', function () {
      self.closeSummary();
    });

    this.elements.summaryDialog.addEventListener('click', function (event) {
      if (event.target === self.elements.summaryDialog) self.closeSummary();
    });

    this.elements.summaryDialog.addEventListener('close', function () {
      self.cleanupSummaryFallback();
      self.restoreSummaryFocus();
    });

    this.elements.summaryDialog.addEventListener('keydown', function (event) {
      self.handleSummaryDialogKeydown(event);
    });
  };

  KitBuilder.prototype.openSummaryDialog = function () {
    var dialog = this.elements.summaryDialog;
    if (!dialog || dialog.open || dialog.hasAttribute('open')) return;

    this.summaryCloseFocusTarget = this.elements.openSummary;
    this.elements.openSummary.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('kit-builder-summary-open');
    var closeButton = dialog.querySelector('[data-kit-close-summary]');
    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
        window.requestAnimationFrame(function () {
          focusElement(closeButton);
        });
        return;
      } catch (error) {
        // Fall through to the progressively enhanced dialog below.
      }
    }

    this.summaryFallbackOpen = true;
    this.root.classList.add('is-summary-fallback-open');
    dialog.classList.add('is-fallback-open');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('open', '');
    window.requestAnimationFrame(function () {
      focusElement(closeButton);
    });
  };

  KitBuilder.prototype.cleanupSummaryFallback = function () {
    this.summaryFallbackOpen = false;
    this.root.classList.remove('is-summary-fallback-open');
    this.elements.summaryDialog.classList.remove('is-fallback-open');
    this.elements.summaryDialog.removeAttribute('role');
    this.elements.summaryDialog.removeAttribute('aria-modal');
    this.elements.openSummary.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('kit-builder-summary-open');
  };

  KitBuilder.prototype.restoreSummaryFocus = function () {
    var target = this.summaryCloseFocusTarget;
    this.summaryCloseFocusTarget = null;
    if (!target) {
      target = this.summaryMediaQuery.matches
        ? this.root.querySelector('.kit-builder__summary--desktop h2')
        : this.elements.openSummary;
    }
    focusElement(target, { preventScroll: true });
  };

  KitBuilder.prototype.closeSummary = function (focusTarget) {
    var dialog = this.elements.summaryDialog;
    if (!dialog || (!dialog.open && !dialog.hasAttribute('open'))) return;
    this.summaryCloseFocusTarget = focusTarget || this.summaryCloseFocusTarget || this.elements.openSummary;

    if (this.summaryFallbackOpen || typeof dialog.close !== 'function') {
      dialog.removeAttribute('open');
      this.cleanupSummaryFallback();
      this.restoreSummaryFocus();
      return;
    }
    dialog.close();
  };

  KitBuilder.prototype.syncSummaryBreakpoint = function () {
    var dialog = this.elements.summaryDialog;
    if (
      !this.summaryMediaQuery.matches ||
      !dialog ||
      (!dialog.open && !dialog.hasAttribute('open'))
    ) return;
    this.closeSummary(this.root.querySelector('.kit-builder__summary--desktop h2'));
  };

  KitBuilder.prototype.handleSummaryDialogKeydown = function (event) {
    if (!this.summaryFallbackOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeSummary();
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = Array.from(this.elements.summaryDialog.querySelectorAll(
      'button:not(:disabled), select:not(:disabled), input:not(:disabled), a[href], [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && !element.closest('[hidden]');
    });
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      focusElement(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusElement(first);
    }
  };

  KitBuilder.prototype.syncFilterPanel = function () {
    this.elements.filterPanel.open = this.filterMediaQuery.matches;
  };

  KitBuilder.prototype.restoreFilterState = function () {
    var params = new URLSearchParams(window.location.search);
    var values = {
      search: normalizeSearchValue(params.get('kit_q')),
      brand: params.get('kit_brand') || 'all',
      category: params.get('kit_category') || '',
      size: canonicalSizeValue(params.get('kit_size') || ''),
      colors: colorFamiliesFromParams(params, 'kit_color'),
      availability: params.get('kit_availability') || 'available',
      minPrice: params.get('kit_min') || '',
      maxPrice: params.get('kit_max') || '',
      sort: params.get('kit_sort') || DEFAULT_SORT
    };

    this.elements.search.value = values.search;
    this.elements.brand.value = ['all', 'dux', 'bux'].includes(values.brand) ? values.brand : 'all';
    this.elements.availability.value = 'available';
    this.selectedColors = values.colors;
    this.elements.minPrice.value = values.minPrice;
    this.elements.maxPrice.value = values.maxPrice;
    this.elements.sort.value = normalizeSort(values.sort);
    if (values.size) {
      var pendingSize = document.createElement('option');
      pendingSize.value = values.size;
      pendingSize.textContent = values.size;
      pendingSize.dataset.kitPendingSize = 'true';
      this.elements.size.appendChild(pendingSize);
      this.elements.size.value = values.size;
    }
    this.syncBrandShortcuts();

    if (values.category) {
      this.knownCategories.add(values.category);
      this.refreshCategoryOptions(values.category);
    }
  };

  KitBuilder.prototype.syncBrandShortcuts = function () {
    var current = this.elements.brand.value;
    this.elements.brandShortcuts.forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        String(button.dataset.kitBrandShortcut === current)
      );
    });
  };

  KitBuilder.prototype.switchBrand = function (nextBrand, focusTarget) {
    var brand = ['all', 'dux', 'bux'].includes(nextBrand) ? nextBrand : 'all';

    // Categories are canonical across both sides of the catalog. Keep the
    // shopper in the same category while switching brands; the destination
    // facets will clear it to All categories only when no true match exists.
    this.elements.brand.value = brand;
    this.syncBrandShortcuts();
    this.syncCategoryShortcuts();
    return this.resetAndFetch({ focusTarget: focusTarget || this.elements.brand });
  };

  KitBuilder.prototype.syncCategoryShortcuts = function () {
    var current = this.elements.category.value;
    var selectedByCategory = new Map();
    this.staged.forEach(function (line) {
      if (!selectedByCategory.has(line.category)) {
        selectedByCategory.set(line.category, new Set());
      }
      selectedByCategory.get(line.category).add(line.productId);
    });
    this.elements.categoryOptions.querySelectorAll('[data-kit-category-shortcut]').forEach(function (button) {
      var category = button.dataset.kitCategoryShortcut;
      var selectedCount = category
        ? (selectedByCategory.get(category) || new Set()).size
        : this.distinctCount();
      button.setAttribute(
        'aria-pressed',
        String(category === current)
      );
      button.textContent = button.dataset.kitCategoryLabel +
        (selectedCount > 0 ? ' (' + selectedCount + ')' : '');
    }, this);
  };

  KitBuilder.prototype.updateUrlState = function () {
    var params = new URLSearchParams(window.location.search);
    var values = this.filterValues();
    var keys = {
      search: 'kit_q',
      brand: 'kit_brand',
      category: 'kit_category',
      size: 'kit_size',
      colors: 'kit_color',
      availability: 'kit_availability',
      minPrice: 'kit_min',
      maxPrice: 'kit_max',
      sort: 'kit_sort'
    };

    Object.keys(values).forEach(function (key) {
      var value = values[key];
      if (key === 'colors') {
        params.delete(keys[key]);
        value.forEach(function (family) {
          params.append(keys[key], family);
        });
        return;
      }
      var defaultValue = key === 'brand'
        ? 'all'
        : key === 'availability'
          ? 'available'
          : key === 'sort'
            ? DEFAULT_SORT
            : '';

      if (!value || value === defaultValue) {
        params.delete(keys[key]);
      } else {
        params.set(keys[key], value);
      }
    });

    var nextUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', nextUrl);
  };

  KitBuilder.prototype.filterValues = function () {
    return {
      search: normalizeSearchValue(this.elements.search.value),
      brand: this.elements.brand.value,
      category: this.elements.category.value,
      size: canonicalSizeValue(this.elements.size.value),
      colors: normalizeColorFamilies(this.selectedColors || []),
      availability: this.elements.availability.value,
      minPrice: this.elements.minPrice.value.trim(),
      maxPrice: this.elements.maxPrice.value.trim(),
      sort: this.elements.sort.value
    };
  };

  KitBuilder.prototype.validatePriceRange = function () {
    var minimum = this.elements.minPrice.value === '' ? null : toNumber(this.elements.minPrice.value, null);
    var maximum = this.elements.maxPrice.value === '' ? null : toNumber(this.elements.maxPrice.value, null);
    var valid = minimum === null || maximum === null || minimum <= maximum;
    this.elements.maxPrice.setCustomValidity(valid ? '' : 'Maximum price must be greater than minimum price.');

    if (!valid) {
      this.elements.maxPrice.reportValidity();
      this.announce('Maximum price must be greater than minimum price.');
    }

    return valid;
  };

  KitBuilder.prototype.resetAndFetch = function (options) {
    options = options && options.focusTarget ? options : {};
    if (this.isSubmitting || !this.config.enabled || !this.validatePriceRange()) return;
    var focusTarget = options.focusTarget || null;
    this.resetCatalogState();
    this.updateUrlState();
    this.updateFilterCount();
    this.track('kit_filter_changed', this.filterValues());
    var request = this.fetchCatalog({ mode: 'replace' });
    if (focusTarget) {
      request.then(function (result) {
        this.focusCatalogResult(result, focusTarget);
      }.bind(this));
    }
    return request;
  };

  KitBuilder.prototype.buildCatalogUrl = function (cursor, catalogRevision) {
    var values = this.filterValues();
    var url = new URL(this.catalogPath, window.location.origin);

    url.searchParams.set('limit', String(this.pageSize));
    if (cursor) url.searchParams.set('cursor', cursor);
    if (catalogRevision) url.searchParams.set('catalog_revision', catalogRevision);
    if (values.search) url.searchParams.set('search', values.search);
    if (values.brand !== 'all') url.searchParams.set('brand', values.brand);
    if (values.category) url.searchParams.set('category', values.category);
    if (values.size) url.searchParams.set('size', values.size);
    normalizeColorFamilies(values.colors || []).forEach(function (family) {
      url.searchParams.append('color', family);
    });
    if (values.minPrice) url.searchParams.set('min_price', values.minPrice);
    if (values.maxPrice) url.searchParams.set('max_price', values.maxPrice);
    url.searchParams.set('sort', values.sort);
    url.searchParams.set('availability', values.availability);
    this.smartPinnedProducts.forEach(function (handle) {
      url.searchParams.append('pin', handle);
    });

    return url;
  };

  KitBuilder.prototype.resetCatalogState = function () {
    this.catalogGeneration += 1;
    if (this.abortController) this.abortController.abort();
    this.abortController = null;
    this.catalogLoading = false;
    this.catalogRetryMode = 'replace';
    this.catalogRevision = null;
    this.pageInfo = { hasNextPage: false, endCursor: null, totalProducts: null };
    this.sortFallbackReason = null;
    this.products = [];
    this.hasLoadedMore = false;
    this.loadMoreFailed = false;
    this.elements.catalog.replaceChildren();
    this.elements.catalog.hidden = true;
    this.elements.catalogWrap.hidden = true;
    this.elements.empty.hidden = true;
    this.elements.resultCount.textContent = '';
    this.updateSortStatus();
    if (this.elements.loadMoreWrap) this.elements.loadMoreWrap.hidden = true;
  };

  KitBuilder.prototype.reloadCatalog = function () {
    this.resetCatalogState();
    return this.fetchCatalog({ mode: 'replace' });
  };

  KitBuilder.prototype.retryCatalogRequest = function () {
    if (this.catalogRetryMode === 'append') {
      focusElement(this.elements.resultCount);
      return this.loadMoreProducts(true);
    }
    var request = this.fetchCatalog({ mode: 'replace' });
    focusElement(this.elements.loading);
    request.then(function (result) {
      this.focusCatalogResult(result);
    }.bind(this));
    return request;
  };

  KitBuilder.prototype.focusCatalogResult = function (result, preferredTarget) {
    var self = this;
    window.requestAnimationFrame(function () {
      var target = null;
      if (
        result &&
        preferredTarget &&
        preferredTarget.isConnected !== false &&
        !preferredTarget.closest('[hidden]')
      ) {
        target = preferredTarget;
      } else if (result && result.firstNewCard) {
        target = result.firstNewCard.querySelector(
          '[data-kit-variant-select]:not(:disabled), [data-kit-add]:not(:disabled)'
        );
      } else if (!self.elements.error.hidden) {
        target = self.root.querySelector('[data-kit-retry]');
      } else if (!self.elements.disabled.hidden) {
        target = self.elements.disabled;
      } else if (!self.elements.empty.hidden) {
        target = self.elements.empty;
      } else if (result) {
        target = self.elements.resultCount;
      }
      focusElement(target);
    });
  };

  KitBuilder.prototype.fetchCatalog = async function (options) {
    options = options || {};
    var mode = options.mode === 'append' ? 'append' : 'replace';
    var appending = mode === 'append';
    var self = this;
    if (!this.config.enabled) return null;
    if (appending && (
      this.catalogLoading ||
      !this.pageInfo.hasNextPage ||
      !this.pageInfo.endCursor
    )) return null;

    var cursor = appending ? this.pageInfo.endCursor : null;
    var requestedRevision = appending ? this.catalogRevision : null;
    var generation = this.catalogGeneration;
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    var requestController = this.abortController;
    var timedOut = false;
    this.catalogLoading = true;
    var timeoutTimer = window.setTimeout(function () {
      timedOut = true;
      requestController.abort();
    }, TRANSACTION_TIMEOUT);

    this.showLoading(mode);

    try {
      var response = await fetch(this.buildCatalogUrl(cursor, requestedRevision).toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: requestController.signal
      });

      var payload = {};
      var parsedPayload = true;
      try {
        payload = await response.json();
      } catch (error) {
        parsedPayload = false;
      }
      if (
        response.status === 409 &&
        payload.error === 'CATALOG_REVISION_STALE' &&
        appending
      ) {
        var staleError = new Error('Kit products changed while more products were loading.');
        staleError.code = 'CATALOG_REVISION_STALE';
        throw staleError;
      }
      if (!response.ok) {
        var responseError = new Error(payload.message || 'The kit catalog did not respond.');
        responseError.code = payload.error || 'CATALOG_REQUEST_FAILED';
        throw responseError;
      }
      if (!parsedPayload || !catalogPayloadIsValid(payload)) {
        var invalidPayload = new Error('The kit catalog returned an invalid response.');
        invalidPayload.code = 'INVALID_CATALOG_RESPONSE';
        throw invalidPayload;
      }

      if (
        requestController !== this.abortController ||
        generation !== this.catalogGeneration
      ) {
        return null;
      }

      if (payload.enabled === false) {
        this.config.enabled = false;
        this.showDisabled(this.disabledReason(payload.reason));
        return null;
      }

      var previewCatalog = this.config.previewMode || payload.previewMode === true;
      if (payload.previewMode === true) this.config.previewMode = true;

      // Preview catalogs provide products, not commerce authority. This keeps
      // the unpublished theme's Rules v3 experience isolated from the
      // currently disabled live Rules v2 configuration. Checkout remains
      // disabled in preview mode; live catalogs still own every commerce rule.
      if (!previewCatalog) {
        if (payload.rulesVersion !== undefined) {
          this.config.rulesVersion = Math.max(1, Math.floor(toNumber(payload.rulesVersion, 3)));
        }
        if (payload.tiers) this.config.tiers = this.normalizeTiers(payload.tiers);
        if (payload.limits) this.config.limits = this.normalizeLimits(payload.limits);
        if (payload.marginalGuard) {
          this.config.marginalGuard = this.normalizeMarginalGuard(payload.marginalGuard);
        }
      }
      if (payload.approvalVersion) this.applyApprovalVersion(payload.approvalVersion);
      if (payload.catalogPath) this.catalogPath = payload.catalogPath;

      var items = payload.items;
      var facetCategories = payload.facets && Array.isArray(payload.facets.categories)
        ? payload.facets.categories
        : [];
      var facetSizes = payload.facets && Array.isArray(payload.facets.sizes)
        ? payload.facets.sizes
        : [];
      var colorFacetsSupported = Boolean(
        payload.colorTaxonomyVersion === 'dux-bux-color-v1' &&
        payload.facets &&
        Array.isArray(payload.facets.colors)
      );
      var facetColors = colorFacetsSupported
        ? payload.facets.colors
        : [];
      this.currencyCode = items[0] && items[0].price && items[0].price.currencyCode
        ? items[0].price.currencyCode
        : this.currencyCode;
      var incomingProducts = groupItemsByProduct(items);
      var previousCount = appending ? this.products.length : 0;
      var addedProducts = incomingProducts;
      if (appending) {
        var existingProductIds = new Set(this.products.map(function (product) {
          return product.productId;
        }));
        addedProducts = incomingProducts.filter(function (product) {
          return !existingProductIds.has(product.productId);
        });
        this.products = this.products.concat(addedProducts);
        this.hasLoadedMore = true;
      } else {
        this.products = incomingProducts;
        this.hasLoadedMore = false;
      }

      var nextPageInfo = payload.pageInfo || {};
      var totalProducts = Number(nextPageInfo.totalProducts);
      this.pageInfo = {
        hasNextPage: nextPageInfo.hasNextPage === true,
        endCursor: nextPageInfo.endCursor || null,
        totalProducts: Number.isInteger(totalProducts) && totalProducts >= 0
          ? totalProducts
          : null
      };
      var sortMetadata = payload.sort && typeof payload.sort === 'object'
        ? payload.sort
        : null;
      this.sortFallbackReason = sortMetadata &&
        sortMetadata.requested === 'best-selling' &&
        sortMetadata.applied === 'newest' &&
        sortMetadata.fallbackReason === 'NO_RECENT_SALES'
          ? 'NO_RECENT_SALES'
          : null;
      this.updateSortStatus();
      this.catalogRevision = typeof payload.catalogRevision === 'string' && payload.catalogRevision
        ? payload.catalogRevision
        : (appending ? this.catalogRevision : null);
      this.loadMoreFailed = false;
      this.catalogRetryMode = mode;

      updateKnownCategories(
        this.knownCategories,
        addedProducts,
        facetCategories,
        appending
      );
      var clearedCategory = this.refreshCategoryOptions(this.elements.category.value);
      var clearedSize = !appending
        ? this.refreshSizeOptions(facetSizes, this.elements.size.value)
        : false;
      var clearedColors = !appending
        ? this.refreshColorOptions(facetColors, colorFacetsSupported)
        : false;
      if (clearedCategory || clearedSize || clearedColors) {
        var clearedLabels = [];
        if (clearedCategory) clearedLabels.push('category');
        if (clearedSize) clearedLabels.push('size');
        if (clearedColors) clearedLabels.push('color');
        this.updateUrlState();
        this.announce(
          'That ' + clearedLabels.join(' and ') +
          (clearedLabels.length > 1 ? ' are' : ' is') +
          ' not available with the current filters. Clearing the unavailable selection.'
        );
        this.resetCatalogState();
        window.setTimeout(function () {
          self.fetchCatalog({ mode: 'replace' });
        }, 0);
        return null;
      }
      this.reconcileLoadedVariants();
      var firstNewCard = this.renderCatalog({
        mode: mode,
        products: addedProducts,
        startIndex: previousCount
      });
      this.showCatalog();
      this.updateLoadMore();
      this.updateFilterCount();
      return {
        addedCount: addedProducts.length,
        firstNewCard: firstNewCard,
        sortFallbackReason: this.sortFallbackReason
      };
    } catch (error) {
      if (
        requestController !== this.abortController ||
        generation !== this.catalogGeneration
      ) return null;

      if (error.code === 'CATALOG_REVISION_STALE') {
        this.announce('Kit products were refreshed. Reloading the list…');
        this.resetCatalogState();
        window.setTimeout(function () {
          self.fetchCatalog({ mode: 'replace' }).then(function (result) {
            self.focusCatalogResult(result);
          });
        }, 0);
        return null;
      }

      if (error.name === 'AbortError') {
        if (timedOut) {
          this.loadMoreFailed = appending;
          this.catalogRetryMode = mode;
          this.showError(
            appending
              ? 'More kit products took too long to load.'
              : 'The kit catalog took too long to load.'
          );
        }
        return null;
      }
      this.loadMoreFailed = appending;
      this.catalogRetryMode = mode;
      this.showError(
        appending
          ? 'More kit products could not load.'
          : (error.message || 'The kit catalog could not load.')
      );
      return null;
    } finally {
      window.clearTimeout(timeoutTimer);
      if (
        requestController === this.abortController &&
        generation === this.catalogGeneration
      ) {
        this.catalogLoading = false;
        this.elements.catalog.setAttribute('aria-busy', 'false');
        this.elements.catalog.classList.remove('is-loading');
        this.updateLoadMore();
      }
    }
  };

  KitBuilder.prototype.disabledReason = function (reason) {
    var reasons = {
      APPROVAL_REQUIRED: 'Kit products are still being prepared.',
      DISABLED: 'The kit builder is temporarily closed.',
      STALE_APPROVAL: 'The kit catalog needs to be refreshed before kits can be built.'
    };
    return reasons[reason] || 'The kit builder is not accepting orders right now.';
  };

  KitBuilder.prototype.updateSortStatus = function () {
    if (!this.elements.sortStatus) return;
    var showFallback = this.elements.sort.value === 'best-selling' &&
      this.sortFallbackReason === 'NO_RECENT_SALES';
    this.elements.sortStatus.hidden = !showFallback;
    this.elements.sortStatus.textContent = showFallback
      ? 'No recent sales yet—showing Newest.'
      : '';
  };

  KitBuilder.prototype.showLoading = function (mode) {
    var appending = mode === 'append';
    var hasCatalog = this.elements.catalog.childElementCount > 0;
    this.elements.loading.hidden = appending || hasCatalog;
    this.elements.disabled.hidden = true;
    this.elements.error.hidden = true;
    this.elements.catalogWrap.hidden = !hasCatalog;
    this.elements.catalog.setAttribute('aria-busy', 'true');
    this.elements.catalog.classList.toggle('is-loading', !appending);
    this.updateLoadMore();
    this.announce(appending ? 'Loading more kit products…' : 'Loading kit products…');
  };

  KitBuilder.prototype.showDisabled = function (message) {
    this.catalogGeneration += 1;
    if (this.abortController) this.abortController.abort();
    this.abortController = null;
    this.catalogLoading = false;
    this.elements.catalog.setAttribute('aria-busy', 'false');
    this.elements.catalog.classList.remove('is-loading');
    this.elements.loading.hidden = true;
    this.elements.error.hidden = true;
    this.elements.catalogWrap.hidden = true;
    this.elements.mobileProgress.hidden = true;
    this.elements.disabledMessage.textContent = message;
    this.elements.disabled.hidden = false;
    if (this.elements.desktopSummary) this.elements.desktopSummary.hidden = true;
    this.root.querySelectorAll('[data-kit-submit]').forEach(function (button) {
      button.disabled = true;
    });
    this.closeSummary(this.elements.disabled);
    focusElement(this.elements.disabled, { preventScroll: true });
    this.announce(message);
  };

  KitBuilder.prototype.showError = function (message) {
    var hasCatalog = this.elements.catalog.childElementCount > 0;
    this.elements.loading.hidden = true;
    this.elements.disabled.hidden = true;
    this.elements.catalogWrap.hidden = !hasCatalog;
    this.elements.errorMessage.textContent = message + ' Check your connection, then retry.';
    this.elements.error.hidden = false;
    this.announce(this.elements.errorMessage.textContent);
  };

  KitBuilder.prototype.showCatalog = function () {
    this.elements.loading.hidden = true;
    this.elements.disabled.hidden = true;
    this.elements.error.hidden = true;
    this.elements.catalogWrap.hidden = false;
    if (this.elements.desktopSummary) this.elements.desktopSummary.hidden = false;
  };

  KitBuilder.prototype.refreshCategoryOptions = function (selectedValue) {
    var select = this.elements.category;
    var current = selectedValue || select.value;
    var categories = Array.from(this.knownCategories).filter(Boolean).sort(function (a, b) {
      var leftIndex = CATEGORY_ORDER.indexOf(a);
      var rightIndex = CATEGORY_ORDER.indexOf(b);
      if (leftIndex === -1 && rightIndex === -1) return compareRuleKeys(a, b);
      if (leftIndex === -1) return 1;
      if (rightIndex === -1) return -1;
      return leftIndex - rightIndex;
    });

    while (select.options.length > 1) select.remove(1);
    categories.forEach(function (category) {
      var option = document.createElement('option');
      option.value = category;
      option.textContent = category;
      select.appendChild(option);
    });
    var canonicalCategory = current
      ? categories.find(function (category) {
          return normalizeCategoryValue(category) === normalizeCategoryValue(current);
        }) || ''
      : '';
    var clearedSelection = Boolean(current && !canonicalCategory);
    select.value = clearedSelection ? '' : canonicalCategory;
    this.refreshCategoryShortcuts(categories);
    return clearedSelection;
  };

  KitBuilder.prototype.refreshCategoryShortcuts = function (categories) {
    var self = this;
    var signature = categories.join('\u001f');
    var options = this.elements.categoryOptions;

    this.elements.categoryQuick.hidden = categories.length === 0;
    if (options.dataset.categorySignature !== signature) {
      var fragment = document.createDocumentFragment();
      [''].concat(categories).forEach(function (category) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.kitCategoryShortcut = category;
        button.dataset.kitCategoryLabel = category || 'All Categories';
        button.textContent = button.dataset.kitCategoryLabel;
        fragment.appendChild(button);
      });
      options.replaceChildren(fragment);
      options.dataset.categorySignature = signature;
    }
    self.syncCategoryShortcuts();
  };

  KitBuilder.prototype.refreshSizeOptions = function (facets, selectedValue) {
    var select = this.elements.size;
    var current = canonicalSizeValue(selectedValue || select.value || '');
    var groups = groupSizeFacets(facets);
    var availableValues = new Set();
    var availableFacetCount = 0;
    var fragment = document.createDocumentFragment();
    var allOption = document.createElement('option');

    allOption.value = '';
    groups.forEach(function (group) {
      group.options.forEach(function (facet) {
        if (facet.available) availableFacetCount += 1;
      });
    });
    allOption.textContent = availableFacetCount > 0 ? 'All sizes' : 'No in-stock sizes';
    fragment.appendChild(allOption);

    groups.forEach(function (group) {
      var optgroup = document.createElement('optgroup');
      optgroup.label = group.label;
      group.options.forEach(function (facet) {
        var option = document.createElement('option');
        if (facet.available) availableValues.add(facet.value);
        option.value = facet.value;
        option.disabled = !facet.available;
        option.textContent = facet.label + (facet.available
          ? (facet.count === null ? '' : ' (' + facet.count + ')')
          : (facet.soldOut ? ' — Sold out' : ' — Unavailable'));
        optgroup.appendChild(option);
      });
      fragment.appendChild(optgroup);
    });

    select.replaceChildren(fragment);
    var clearedSelection = Boolean(current && !availableValues.has(current));
    select.value = clearedSelection ? '' : current;
    select.disabled = availableFacetCount === 0;
    if (select.disabled) {
      select.dataset.kitSizeUnavailable = 'true';
    } else {
      delete select.dataset.kitSizeUnavailable;
    }
    return clearedSelection;
  };

  KitBuilder.prototype.syncColorControls = function () {
    var selected = new Set(normalizeColorFamilies(this.selectedColors || []));
    if (this.elements.colorAll) {
      this.elements.colorAll.setAttribute('aria-pressed', String(selected.size === 0));
    }
    if (!this.elements.colorOptions) return;
    this.elements.colorOptions.querySelectorAll('[data-kit-color]').forEach(function (input) {
      input.checked = selected.has(input.value);
      var chip = input.closest('.kit-builder__color-chip');
      if (chip) chip.classList.toggle('is-selected', input.checked);
    });
    this.syncColorSummary();
  };

  KitBuilder.prototype.syncColorSummary = function () {
    if (!this.elements.colorSummary || !this.elements.colorTrigger) return;
    var selected = normalizeColorFamilies(this.selectedColors || []);
    var labels = selected.map(function (family) {
      return COLOR_FAMILY_LABELS[family] || family;
    });
    var summary = 'All colors';
    if (labels.length === 1) {
      summary = labels[0];
    } else if (labels.length === 2) {
      summary = labels.join(' + ');
    } else if (labels.length > 2) {
      summary = labels[0] + ' + ' + (labels.length - 1) + ' more';
    }
    this.elements.colorSummary.textContent = summary;
    this.elements.colorTrigger.setAttribute('aria-label', 'Shop by Color: ' + summary);
  };

  KitBuilder.prototype.refreshColorOptions = function (facets, supported) {
    if (!this.elements.colorField || !this.elements.colorOptions) return false;
    var normalized = normalizeColorFacets(facets);
    var selected = normalizeColorFamilies(this.selectedColors || []);

    if (!supported) {
      var hadSelection = selected.length > 0;
      this.selectedColors = [];
      this.elements.colorOptions.replaceChildren();
      this.closeColorDropdown(false);
      this.elements.colorField.hidden = true;
      this.syncColorControls();
      return hadSelection;
    }

    if (!normalized.length && !selected.length) {
      this.elements.colorOptions.replaceChildren();
      this.closeColorDropdown(false);
      this.elements.colorField.hidden = true;
      this.syncColorControls();
      return false;
    }

    var facetsByValue = new Map(normalized.map(function (facet) {
      return [facet.value, facet];
    }));
    var orderedFacets = normalized.slice();
    selected.forEach(function (family) {
      if (!facetsByValue.has(family)) {
        var missingFacet = {
          value: family,
          label: COLOR_FAMILY_LABELS[family],
          count: 0,
          available: false,
          soldOut: false
        };
        facetsByValue.set(family, missingFacet);
        orderedFacets.push(missingFacet);
      }
    });
    var fragment = document.createDocumentFragment();
    orderedFacets.forEach(function (facet) {
      var isSelected = selected.includes(facet.value);
      var status = facet.available
        ? (facet.count === null ? '' : facet.count + (facet.count === 1 ? ' product' : ' products'))
        : (facet.soldOut ? 'Sold out' : 'Unavailable');
      var chip = document.createElement('label');
      chip.className = 'kit-builder__color-chip';
      chip.classList.toggle('is-selected', isSelected);
      chip.classList.toggle('is-unavailable', !facet.available);
      chip.dataset.colorFamily = facet.value;

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.name = 'kit_color';
      input.value = facet.value;
      input.checked = isSelected;
      input.disabled = !facet.available && !isSelected;
      input.dataset.kitColor = facet.value;
      input.setAttribute(
        'aria-label',
        facet.label + (status ? ', ' + status : '')
      );
      chip.appendChild(input);

      var swatch = document.createElement('span');
      swatch.className = 'kit-builder__color-swatch';
      swatch.setAttribute('aria-hidden', 'true');
      chip.appendChild(swatch);

      var label = document.createElement('span');
      label.className = 'kit-builder__color-label';
      label.textContent = facet.label;
      chip.appendChild(label);

      if (status) {
        var count = document.createElement('span');
        count.className = 'kit-builder__color-count';
        count.textContent = facet.available && facet.count !== null
          ? '(' + facet.count + ')'
          : status;
        count.setAttribute('aria-hidden', 'true');
        chip.appendChild(count);
      }
      fragment.appendChild(chip);
    });

    this.elements.colorOptions.replaceChildren(fragment);
    this.elements.colorField.hidden = false;
    this.syncColorControls();
    return false;
  };

  KitBuilder.prototype.renderCatalog = function (options) {
    options = options || {};
    var appending = options.mode === 'append';
    var products = Array.isArray(options.products) ? options.products : this.products;
    var startIndex = Math.max(0, toNumber(options.startIndex, 0));
    var self = this;
    var fragment = document.createDocumentFragment();
    var firstNewCard = null;

    if (!appending) this.elements.catalog.replaceChildren();

    products.forEach(function (product, index) {
      var card = self.createProductCard(product, startIndex + index);
      if (!firstNewCard) firstNewCard = card;
      fragment.appendChild(card);
    });
    this.elements.catalog.appendChild(fragment);

    var count = this.products.length;
    var total = this.pageInfo.totalProducts;
    this.elements.resultCount.textContent = total !== null
      ? 'Showing ' + count + ' of ' + total + ' kit products'
      : count + ' kit ' + (count === 1 ? 'product' : 'products') + ' shown';
    this.elements.empty.hidden = count > 0;
    this.elements.catalog.hidden = count === 0;
    this.announce(
      count > 0
        ? (appending
            ? products.length + ' more ' + (products.length === 1 ? 'product' : 'products') +
              ' loaded. ' + this.elements.resultCount.textContent + '.'
            : this.elements.resultCount.textContent)
        : 'No kit products match the current filters.'
    );
    if (this.isSubmitting) {
      this.setSubmittingState(true);
    } else {
      this.setPendingSelectionState(this.cartAddUncertain);
    }
    return firstNewCard;
  };

  KitBuilder.prototype.createProductCard = function (product, index) {
    var activeSize = this.elements.size ? this.elements.size.value : '';
    var activeColors = normalizeColorFamilies(this.selectedColors || []);
    var activeMinPrice = this.elements.minPrice ? this.elements.minPrice.value : '';
    var activeMaxPrice = this.elements.maxPrice ? this.elements.maxPrice.value : '';
    if (
      activeSize ||
      activeColors.length ||
      normalizedPriceBound(activeMinPrice) !== null ||
      normalizedPriceBound(activeMaxPrice) !== null
    ) {
      var filteredVariants = matchingCardVariants(
        product.variants,
        activeSize,
        activeColors,
        activeMinPrice,
        activeMaxPrice
      );
      // The backend returns sibling variants so it can explain sold-out facet
      // states. Keep the buying control constrained to the same variant-level
      // color/size/price intersection used for the catalog match.
      product = Object.assign({}, product, { variants: filteredVariants });
    }
    var article = document.createElement('article');
    var titleId = 'KitProduct-' + this.sectionId + '-' + index;
    var selectId = 'KitVariant-' + this.sectionId + '-' + index;
    var priceId = 'KitPrice-' + this.sectionId + '-' + index;
    var ruleId = 'KitRule-' + this.sectionId + '-' + index;
    var selectedQuantity = this.productQuantity(product.productId);
    var firstAvailable = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
    var stagedVariant = product.variants.find(function (variant) {
      return this.staged.has(variant.variantId);
    }, this);
    var filteredVariant = unambiguousVariantForFilters(
      product.variants,
      activeSize,
      activeColors,
      activeMinPrice,
      activeMaxPrice
    );
    // Filtering may safely preselect only one exact purchasable match.
    var initialVariant = stagedVariant || filteredVariant ||
      (product.variants.length === 1 ? firstAvailable : null);
    var displayVariant = initialVariant || firstAvailable;

    article.className = 'kit-builder__product';
    article.classList.toggle('is-single-variant', product.variants.length === 1);
    article.dataset.kitProductCard = '';
    article.dataset.productId = product.productId;
    article.dataset.familyKey = product.familyKey;
    article.dataset.slotKey = product.slotKey;
    article.dataset.tierRole = product.tierRole;
    article.dataset.selected = selectedQuantity > 0 ? 'true' : 'false';
    article.setAttribute('aria-labelledby', titleId);

    var media = document.createElement('div');
    media.className = 'kit-builder__product-media';

    if (product.tierRole === 'addon') {
      var badges = document.createElement('div');
      badges.className = 'kit-builder__product-badges';
      var addonBadge = document.createElement('span');
      addonBadge.className = 'kit-builder__badge kit-builder__badge--addon';
      addonBadge.textContent = 'ADD-ON';
      badges.appendChild(addonBadge);
      media.appendChild(badges);
    }

    var image = document.createElement('img');
    image.dataset.kitProductImage = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    var displayImage = displayVariant && displayVariant.image
      ? displayVariant.image
      : product.image;
    if (displayImage) {
      image.alt = displayImage.altText || product.title;
      applyResponsiveImage(
        image,
        displayImage,
        PRODUCT_IMAGE_SIZES
      );
    } else {
      image.alt = '';
      image.width = 800;
      image.height = 800;
    }
    media.appendChild(image);

    var info = document.createElement('div');
    info.className = 'kit-builder__product-info';

    var category = document.createElement('p');
    category.className = 'kit-builder__product-category';
    category.textContent = product.category;
    info.appendChild(category);

    var title = document.createElement('h2');
    title.className = 'kit-builder__product-title';
    title.id = titleId;
    title.textContent = product.title;
    info.appendChild(title);

    var price = document.createElement('p');
    price.className = 'kit-builder__product-price';
    price.id = priceId;
    price.dataset.kitProductPrice = '';
    price.setAttribute('aria-live', 'polite');
    info.appendChild(price);

    var rule = document.createElement('p');
    rule.className = 'kit-builder__product-rule';
    rule.id = ruleId;
    rule.dataset.kitProductRule = '';
    info.appendChild(rule);

    if (product.variants.length > 1) {
      var variantLabel = document.createElement('label');
      variantLabel.className = 'kit-builder__variant-label';
      variantLabel.htmlFor = selectId;
      variantLabel.appendChild(document.createTextNode('Choose option'));

      var select = document.createElement('select');
      select.id = selectId;
      select.dataset.kitVariantSelect = '';
      select.setAttribute('aria-label', 'Choose an option for ' + product.title);
      select.setAttribute('aria-describedby', priceId + ' ' + ruleId);
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Choose an option';
      placeholder.disabled = true;
      placeholder.selected = !initialVariant;
      select.appendChild(placeholder);
      product.variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = variant.variantId;
        option.textContent = variant.variantTitle + (variant.available ? '' : ' — Sold out');
        option.disabled = !variant.available;
        option.selected = Boolean(initialVariant && variant.variantId === initialVariant.variantId);
        select.appendChild(option);
      });
      variantLabel.appendChild(select);
      info.appendChild(variantLabel);
    } else if (firstAvailable) {
      var singleOption = document.createElement('div');
      singleOption.className = 'kit-builder__single-option';
      singleOption.dataset.kitSingleOption = '';

      var singleOptionLabel = document.createElement('span');
      singleOptionLabel.className = 'kit-builder__single-option-label';
      singleOptionLabel.textContent = 'Option';
      singleOption.appendChild(singleOptionLabel);

      var singleOptionControl = document.createElement('div');
      singleOptionControl.className = 'kit-builder__single-option-control';

      var singleOptionValue = document.createElement('span');
      singleOptionValue.className = 'kit-builder__single-option-value';
      singleOptionValue.textContent = optionLabel(firstAvailable);
      singleOptionControl.appendChild(singleOptionValue);

      if (!firstAvailable.available) {
        var singleOptionStatus = document.createElement('span');
        singleOptionStatus.className = 'kit-builder__single-option-status';
        singleOptionStatus.textContent = 'Sold out';
        singleOptionControl.appendChild(singleOptionStatus);
      }

      singleOption.appendChild(singleOptionControl);
      info.appendChild(singleOption);
    }

    var actions = document.createElement('div');
    actions.className = 'kit-builder__card-actions';
    var decrement = this.createLineButton(
      'decrement',
      initialVariant ? initialVariant.variantId : '',
      'Decrease quantity for ' + product.title,
      '−'
    );
    decrement.className = 'kit-builder__card-decrement';
    decrement.dataset.kitCardDecrement = '';
    decrement.hidden = true;
    actions.appendChild(decrement);
    var cardQuantity = document.createElement('output');
    cardQuantity.dataset.kitCardQuantity = '';
    cardQuantity.setAttribute('aria-label', 'Quantity of ' + product.title + ' in kit');
    cardQuantity.hidden = true;
    actions.appendChild(cardQuantity);

    var button = document.createElement('button');
    button.className = 'kit-builder__add-button';
    button.type = 'button';
    button.dataset.kitAdd = '';
    button.textContent = selectedQuantity > 0 ? 'Add Another' : 'Add to Kit';
    actions.appendChild(button);
    info.appendChild(actions);

    article.appendChild(media);
    article.appendChild(info);
    article._kitProduct = product;
    this.updateProductCardRule(article);
    this.updateCardVariant(article, initialVariant ? initialVariant.variantId : '');
    return article;
  };

  KitBuilder.prototype.updateProductCardRule = function (card) {
    if (!card || !card._kitProduct) return;
    var product = card._kitProduct;
    var rule = card.querySelector('[data-kit-product-rule]');
    if (!rule) return;

    rule.classList.toggle('is-addon', product.tierRole === 'addon');
    if (product.tierRole === 'addon') {
      rule.textContent = 'Discount applies · no savings progress';
      return;
    }
    rule.textContent = 'Moves your savings progress';
  };

  KitBuilder.prototype.updateCardVariant = function (card, variantId) {
    if (!card || !card._kitProduct) return;
    var product = card._kitProduct;
    var variant = product.variants.find(function (entry) {
      return entry.variantId === variantId;
    }) || null;
    var price = card.querySelector('[data-kit-product-price]');
    var button = card.querySelector('[data-kit-add]');
    var image = card.querySelector('[data-kit-product-image]');
    var actions = card.querySelector('.kit-builder__card-actions');
    var decrement = card.querySelector('[data-kit-card-decrement]');
    var quantityOutput = card.querySelector('[data-kit-card-quantity]');
    var unitTotal = this.totalUnits();

    if (!variant) {
      var priceCandidates = productPriceCandidates(product.variants);
      if (!priceCandidates.length) {
        card.dataset.variantId = '';
        price.textContent = 'Unavailable';
        actions.classList.remove('is-stepper');
        decrement.hidden = true;
        quantityOutput.hidden = true;
        button.disabled = true;
        button.textContent = 'Unavailable';
        button.setAttribute('aria-label', product.title + ' is unavailable with these filters');
        return;
      }
      var startingPrice = priceCandidates.reduce(function (minimum, entry) {
        return Math.min(minimum, toNumber(entry.price.amount, minimum));
      }, Number.POSITIVE_INFINITY);
      var currencyCode = priceCandidates[0] && priceCandidates[0].price.currencyCode;
      card.dataset.variantId = '';
      price.textContent = 'From ' + this.formatMoney(startingPrice, currencyCode);
      actions.classList.remove('is-stepper');
      decrement.hidden = true;
      quantityOutput.hidden = true;
      button.disabled = true;
      button.textContent = 'Choose Option';
      button.setAttribute('aria-label', 'Choose an option for ' + product.title + ' before adding it');
      return;
    }

    var productTotal = this.productQuantity(variant.productId);
    var familyTotal = this.familyQuantity(variant.familyKey);
    var stagedLine = this.staged.get(variant.variantId);
    var variantQuantity = stagedLine ? stagedLine.quantity : 0;

    card.dataset.variantId = variant.variantId;
    decrement.dataset.variantId = variant.variantId;
    decrement.hidden = variantQuantity === 0;
    quantityOutput.hidden = variantQuantity === 0;
    quantityOutput.textContent = variantQuantity;
    quantityOutput.value = variantQuantity;
    actions.classList.toggle('is-stepper', variantQuantity > 0);
    price.replaceChildren(document.createTextNode(this.formatMoney(variant.price.amount, variant.price.currencyCode)));
    if (
      variant.compareAtPrice &&
      toNumber(variant.compareAtPrice.amount, 0) > toNumber(variant.price.amount, 0)
    ) {
      var compare = document.createElement('s');
      compare.className = 'price__was';
      compare.textContent = this.formatMoney(variant.compareAtPrice.amount, variant.compareAtPrice.currencyCode);
      price.appendChild(compare);
    }

    if (variant.image) {
      applyResponsiveImage(
        image,
        variant.image,
        PRODUCT_IMAGE_SIZES,
        [240, 360, 480, 640]
      );
      image.alt = variant.image.altText || variant.title;
    }

    button.disabled = this.cartAddUncertain ||
      !variant.available ||
      productTotal >= this.config.limits.maxPerProduct ||
      familyTotal >= this.config.limits.maxPerFamily ||
      unitTotal >= this.config.limits.maxUnitsPerKit;
    if (!variant.available) {
      button.textContent = variantQuantity > 0 ? '+' : 'Sold Out';
      button.setAttribute('aria-label', product.title + ' is sold out');
    } else if (productTotal >= this.config.limits.maxPerProduct) {
      button.textContent = variantQuantity > 0 ? '+' : 'Product Limit Reached';
      button.setAttribute('aria-label', 'Product limit reached for ' + product.title);
    } else if (familyTotal >= this.config.limits.maxPerFamily) {
      button.textContent = variantQuantity > 0 ? '+' : 'Product Limit Reached';
      button.setAttribute('aria-label', 'Product limit reached for ' + product.title);
    } else if (unitTotal >= this.config.limits.maxUnitsPerKit) {
      button.textContent = variantQuantity > 0 ? '+' : 'Kit Limit Reached';
      button.setAttribute('aria-label', 'Kit limit reached; cannot add ' + product.title);
    } else {
      button.textContent = variantQuantity > 0 ? '+' : (productTotal > 0 ? 'Add Another' : 'Add to Kit');
      button.setAttribute(
        'aria-label',
        (productTotal > 0 ? 'Add another ' : 'Add ') + product.title + ' to kit'
      );
    }
  };

  KitBuilder.prototype.refreshVisibleCards = function () {
    var self = this;
    this.elements.catalog.querySelectorAll('[data-kit-product-card]').forEach(function (card) {
      card.dataset.selected = self.productQuantity(card.dataset.productId) > 0 ? 'true' : 'false';
      self.updateProductCardRule(card);
      self.updateCardVariant(card, card.dataset.variantId);
    });
  };

  KitBuilder.prototype.addFromCard = function (card) {
    if (this.isSubmitting || this.cartAddUncertain) return;
    var variantId = card && card.dataset.variantId;
    var product = card && card._kitProduct;
    var variant = product && product.variants.find(function (entry) {
      return entry.variantId === variantId;
    });
    if (!variant || !variant.available) return;

    if (this.productQuantity(variant.productId) >= this.config.limits.maxPerProduct) {
      this.announce('You can add no more than ' + this.config.limits.maxPerProduct + ' units from one product.');
      return;
    }
    if (this.familyQuantity(variant.familyKey) >= this.config.limits.maxPerFamily) {
      this.announce('You have reached the quantity limit for this product.');
      return;
    }
    if (this.totalUnits() >= this.config.limits.maxUnitsPerKit) {
      this.announce('A kit can contain no more than ' + this.config.limits.maxUnitsPerKit + ' total units.');
      return;
    }

    var previousTierUnitCount = this.tierUnitCount();
    var existing = this.staged.get(variant.variantId);
    if (existing) {
      existing.quantity += 1;
    } else {
      this.staged.set(variant.variantId, Object.assign({}, variant, { quantity: 1 }));
    }

    this.persistStaged();
    this.renderSummary();
    this.refreshVisibleCards();
    var evaluation = this.savingsEvaluation();
    var currentTierUnitCount = evaluation.tierUnitCount;
    var ruleMessage = variant.tierRole === 'addon'
      ? ' The discount applies, but savings progress did not change.'
      : ' Savings progress is now ' + currentTierUnitCount + ' ' +
        (currentTierUnitCount === 1 ? 'item.' : 'items.');
    this.announce(
      variant.title + ', ' + variant.variantTitle + ', added to your kit.' + ruleMessage
    );
    this.track('kit_product_staged', {
      product_id: variant.productId,
      variant_id: variant.variantId,
      family_key: variant.familyKey,
      slot_key: variant.slotKey,
      tier_role: variant.tierRole,
      brand: variant.brand,
      category: variant.category,
      quantity: existing ? existing.quantity : 1,
      tier_units: currentTierUnitCount,
      qualifying_picks: currentTierUnitCount,
      previous_tier_units: previousTierUnitCount
    });
  };

  KitBuilder.prototype.handleLineAction = function (button) {
    if (this.isSubmitting || this.cartAddUncertain) return;
    var focusContext = this.captureLineActionFocus(button);
    var variantId = button.dataset.variantId;
    var action = button.dataset.kitLineAction;
    var line = this.staged.get(variantId);
    if (!line) return;

    if (action === 'remove') {
      this.staged.delete(variantId);
      this.announce(line.title + ' removed from your kit.');
      this.track('kit_product_removed', {
        product_id: line.productId,
        variant_id: line.variantId,
        brand: line.brand,
        category: line.category
      });
    } else if (action === 'decrement') {
      line.quantity -= 1;
      if (line.quantity <= 0) {
        this.staged.delete(variantId);
        this.announce(line.title + ' removed from your kit.');
        this.track('kit_product_removed', {
          product_id: line.productId,
          variant_id: line.variantId,
          brand: line.brand,
          category: line.category
        });
      } else {
        this.announce(
          'Quantity of ' + line.title + ' decreased to ' + line.quantity + '.'
        );
      }
    } else if (action === 'increment') {
      if (this.productQuantity(line.productId) >= this.config.limits.maxPerProduct) {
        this.announce('You can add no more than ' + this.config.limits.maxPerProduct + ' units from one product.');
        return;
      }
      if (this.familyQuantity(line.familyKey) >= this.config.limits.maxPerFamily) {
        this.announce('You have reached the quantity limit for this product.');
        return;
      }
      if (this.totalUnits() >= this.config.limits.maxUnitsPerKit) {
        this.announce('A kit can contain no more than ' + this.config.limits.maxUnitsPerKit + ' total units.');
        return;
      }
      line.quantity += 1;
      this.announce('Quantity updated.');
    }

    this.persistStaged();
    this.renderSummary();
    this.refreshVisibleCards();
    this.restoreLineActionFocus(focusContext);
  };

  KitBuilder.prototype.captureLineActionFocus = function (button) {
    if (!button || document.activeElement !== button) return null;

    var context = {
      action: button.dataset.kitLineAction,
      variantId: button.dataset.variantId
    };
    var summary = button.closest('[data-kit-summary]');
    if (summary) {
      var visualItem = button.closest('.kit-builder__visual-item');
      if (visualItem) {
        var visualItems = Array.from(summary.querySelectorAll('.kit-builder__visual-item'));
        context.type = 'visual';
        context.summaryContext = summary.dataset.summaryContext;
        context.visualIndex = Math.max(0, visualItems.indexOf(visualItem));
        return context;
      }
      var line = button.closest('.kit-builder__line');
      var lines = Array.from(summary.querySelectorAll('.kit-builder__line'));
      context.type = 'summary';
      context.summaryContext = summary.dataset.summaryContext;
      context.lineIndex = Math.max(0, lines.indexOf(line));
      return context;
    }

    var card = button.closest('[data-kit-product-card]');
    if (card) {
      context.type = 'card';
      context.card = card;
      return context;
    }
    return null;
  };

  KitBuilder.prototype.restoreLineActionFocus = function (context) {
    if (!context) return;
    var self = this;
    window.requestAnimationFrame(function () {
      var target = null;
      if (context.type === 'card' && context.card && context.card.isConnected !== false) {
        var cardControls = Array.from(context.card.querySelectorAll(
          '[data-kit-line-action], [data-kit-variant-select], [data-kit-add]'
        ));
        target = cardControls.find(function (control) {
          return control.dataset.kitLineAction === context.action &&
            control.dataset.variantId === context.variantId &&
            !control.disabled && !control.hidden;
        }) || cardControls.find(function (control) {
          return !control.disabled && !control.hidden;
        });
      } else if (context.type === 'summary' || context.type === 'visual') {
        var summary = self.elements.summaries.find(function (entry) {
          return entry.dataset.summaryContext === context.summaryContext;
        });
        if (summary) {
          var controlSelector = context.type === 'visual'
            ? '.kit-builder__visual-remove'
            : '[data-kit-line-action]';
          var summaryControls = Array.from(summary.querySelectorAll(controlSelector));
          target = summaryControls.find(function (control) {
            return control.dataset.kitLineAction === context.action &&
              control.dataset.variantId === context.variantId &&
              !control.disabled;
          }) || summaryControls.find(function (control) {
            return control.dataset.variantId === context.variantId && !control.disabled;
          });

          if (!target && context.type === 'visual') {
            var visualItems = Array.from(summary.querySelectorAll('.kit-builder__visual-item'));
            var nextVisualItem = visualItems[
              Math.min(context.visualIndex, Math.max(0, visualItems.length - 1))
            ];
            target = nextVisualItem && nextVisualItem.querySelector(
              '.kit-builder__visual-remove:not(:disabled)'
            );
          }
          if (!target && context.type === 'summary') {
            var lines = Array.from(summary.querySelectorAll('.kit-builder__line'));
            var nextLine = lines[Math.min(context.lineIndex, Math.max(0, lines.length - 1))];
            target = nextLine && nextLine.querySelector('[data-kit-line-action]:not(:disabled)');
          }
          if (!target) {
            target = summary.closest('.kit-builder__summary, .kit-builder__summary-sheet').querySelector('h2');
          }
        }
      }
      focusElement(target);
    });
  };

  KitBuilder.prototype.productQuantity = function (productId) {
    return productUnitCount(Array.from(this.staged.values()), productId);
  };

  KitBuilder.prototype.familyQuantity = function (familyKey) {
    return familyUnitCount(Array.from(this.staged.values()), familyKey);
  };

  KitBuilder.prototype.totalUnits = function () {
    var total = 0;
    this.staged.forEach(function (line) {
      total += line.quantity;
    });
    return total;
  };

  KitBuilder.prototype.distinctCount = function () {
    var products = new Set();
    this.staged.forEach(function (line) {
      if (line.quantity > 0) products.add(line.productId);
    });
    return products.size;
  };

  KitBuilder.prototype.savingsEvaluation = function () {
    return marginalSafePercent(
      Array.from(this.staged.values()),
      this.config.tiers,
      this.config.limits,
      this.config.marginalGuard
    );
  };

  KitBuilder.prototype.tierUnitCount = function () {
    return this.savingsEvaluation().tierUnitCount;
  };

  KitBuilder.prototype.subtotal = function () {
    var subtotal = 0;
    this.staged.forEach(function (line) {
      subtotal += line.price.amount * line.quantity;
    });
    return subtotal;
  };

  KitBuilder.prototype.renderSummary = function () {
    var self = this;
    var evaluation = this.savingsEvaluation();
    var itemCount = evaluation.tierUnitCount;
    var totalUnits = this.totalUnits();
    var subtotal = evaluation.subtotalCents / 100;
    var savings = evaluation.savingsCents / 100;
    var total = evaluation.totalCents / 100;
    var upcoming = nextTier(this.config.tiers, itemCount);
    var nextLabel;
    if (evaluation.percent < evaluation.earnedPercent) {
      nextLabel = 'This kit is currently estimated at ' + evaluation.percent + '% off';
    } else if (upcoming) {
      nextLabel = 'Add ' + (upcoming.units - itemCount) + ' more ' +
        (upcoming.units - itemCount === 1 ? 'item' : 'items') +
        ' for up to ' + upcoming.percent + '% off';
    } else {
      nextLabel = 'Maximum savings reached';
    }

    this.elements.summaries.forEach(function (summary) {
      self.renderSummaryInstance(summary, {
        tierUnitCount: itemCount,
        totalUnits: totalUnits,
        subtotal: subtotal,
        savings: savings,
        total: total,
        safePercent: evaluation.percent,
        earnedPercent: evaluation.earnedPercent,
        nextLabel: nextLabel
      });
    });

    var mobileRewardStatus = evaluation.percent > 0
      ? 'Est. ' + evaluation.percent + '% off'
      : evaluation.earnedPercent > 0
        ? 'Tier reached'
        : 'Building first tier';
    this.elements.mobileCount.textContent = itemCount + ' ' +
      (itemCount === 1 ? 'item' : 'items') + ' · ' + mobileRewardStatus;
    this.elements.mobileNext.textContent = nextLabel;
    this.elements.mobileTotal.textContent = this.formatMoney(total, this.currencyCode);
    var progressTarget = this.config.tiers[this.config.tiers.length - 1].units;
    var progress = Math.min(1, itemCount / Math.max(1, progressTarget));
    this.elements.progressFill.style.transform = 'scaleX(' + progress + ')';
    this.renderTierList(itemCount, evaluation.percent);

    if (evaluation.percent > this.lastSafePercent) {
      this.track('kit_tier_unlocked', {
        tier_units: itemCount,
        qualifying_picks: itemCount,
        percent: evaluation.percent,
        earned_percent: evaluation.earnedPercent
      });
    }
    this.lastTierUnitCount = itemCount;
    this.lastSafePercent = evaluation.percent;
    this.syncCategoryShortcuts();

  };

  KitBuilder.prototype.renderDiscountProgress = function (summary, totals) {
    var progressCard = summary.querySelector('[data-kit-discount-progress]');
    if (!progressCard) return;

    var progressStatus = progressCard.querySelector('[data-kit-progress-status]');
    var progressTitle = progressCard.querySelector('[data-kit-progress-title]');
    var progressDetail = progressCard.querySelector('[data-kit-progress-detail]');
    var progressBar = progressCard.querySelector('[data-kit-summary-progress]');
    var progressFill = progressBar && progressBar.querySelector('[data-kit-progress-fill]');
    var milestones = progressCard.querySelector('[data-kit-progress-milestones]');
    var tiers = this.config.tiers;
    var firstTier = tiers[0] || { units: 4, percent: 10 };
    var topTier = tiers[tiers.length - 1] || firstTier;
    var upcoming = nextTier(tiers, totals.tierUnitCount);
    var itemsNeeded = upcoming
      ? Math.max(0, upcoming.units - totals.tierUnitCount)
      : 0;
    var displayCount = Math.min(totals.tierUnitCount, topTier.units);
    var statusText;
    var titleText;
    var detailText;
    var valueText;

    if (totals.tierUnitCount < firstTier.units) {
      statusText = 'Keep Building';
      titleText = 'Add ' + itemsNeeded + ' ' +
        (itemsNeeded === 1 ? 'Item' : 'Items') + ' To Save Up To ' + upcoming.percent + '%';
      detailText = 'The more gear you add, the more you save.';
    } else if (upcoming) {
      statusText = totals.safePercent > 0
        ? 'Est. ' + totals.safePercent + '% Off'
        : 'Keep Building';
      titleText = 'Add ' + itemsNeeded + ' More ' +
        (itemsNeeded === 1 ? 'Item' : 'Items') + ' To Save Up To ' + upcoming.percent + '%';
      detailText = 'The more gear you add, the more you save.';
      if (totals.safePercent < totals.earnedPercent) {
        detailText = 'This kit is currently estimated at ' + totals.safePercent + '% off.';
      }
    } else {
      statusText = totals.safePercent > 0
        ? 'Max Savings'
        : 'Keep Building';
      titleText = 'Maximum Savings Reached';
      detailText = totals.safePercent < totals.earnedPercent
        ? 'This kit is currently estimated at ' + totals.safePercent + '% off.'
        : 'Your kit has reached up to ' + topTier.percent + '% off.';
    }

    progressStatus.textContent = statusText;
    progressTitle.textContent = titleText;
    progressDetail.textContent = detailText;
    progressCard.dataset.progressState = upcoming ? 'building' : 'complete';

    if (progressBar) {
      valueText = 'Savings progress: ' + displayCount + ' of ' + topTier.units + ' items. ';
      if (totals.safePercent > 0) {
        valueText += 'Estimated discount ' + totals.safePercent + ' percent. ';
      }
      valueText += upcoming
        ? 'Add ' + itemsNeeded + ' more ' + (itemsNeeded === 1 ? 'item' : 'items') +
          ' to save up to ' + upcoming.percent + ' percent.'
        : 'Maximum savings reached.';
      progressBar.setAttribute('aria-valuenow', String(displayCount));
      progressBar.setAttribute('aria-valuemax', String(topTier.units));
      progressBar.setAttribute('aria-valuetext', valueText);
    }
    if (progressFill) {
      progressFill.style.transform = 'scaleX(' +
        Math.min(1, displayCount / Math.max(1, topTier.units)) + ')';
    }

    if (!milestones) return;
    milestones.querySelectorAll('[data-kit-tier-threshold]').forEach(function (item) {
      var threshold = toNumber(item.dataset.kitTierThreshold, 0);
      var percent = toNumber(item.dataset.kitTierPercent, 0);
      var isEarned = totals.tierUnitCount >= threshold;
      var isActive = isEarned && percent === totals.safePercent && totals.safePercent > 0;
      var isNext = Boolean(upcoming && threshold === upcoming.units);
      var state = item.querySelector('[data-kit-tier-state]');

      item.classList.toggle('is-earned', isEarned);
      item.classList.toggle('is-active', isActive);
      item.classList.toggle('is-next', isNext);
      if (isNext || (!upcoming && threshold === topTier.units)) {
        item.setAttribute('aria-current', 'step');
      } else {
        item.removeAttribute('aria-current');
      }
      if (state) {
        state.textContent = isActive
          ? 'Unlocked'
          : isEarned
            ? 'Unlocked'
            : isNext
              ? 'Next'
              : threshold === topTier.units
                ? 'Max'
                : 'Save more';
      }
    });
  };

  KitBuilder.prototype.renderSummaryInstance = function (summary, totals) {
    var self = this;
    var lines = summary.querySelector('[data-kit-lines]');
    var visual = summary.querySelector('[data-kit-visual]');
    var visualWrap = summary.querySelector('[data-kit-visual-wrap]');
    var visualCount = summary.querySelector('[data-kit-visual-count]');
    var empty = summary.querySelector('[data-kit-summary-empty]');
    var selected = summary.querySelector('[data-kit-selected]');
    var subtotal = summary.querySelector('[data-kit-subtotal]');
    var savings = summary.querySelector('[data-kit-savings]');
    var total = summary.querySelector('[data-kit-total]');
    var safePercent = summary.querySelector('[data-kit-safe-percent]');
    var actionTotal = summary.querySelector('[data-kit-action-total]');
    var submit = summary.querySelector('[data-kit-submit]');
    var submitLabel = summary.querySelector('[data-kit-submit-label]');

    lines.replaceChildren();
    visual.replaceChildren();
    this.staged.forEach(function (line) {
      lines.appendChild(self.createSummaryLine(line));
      visual.appendChild(self.createVisualItem(line));
    });

    empty.hidden = totals.totalUnits > 0;
    var firstTier = this.config.tiers[0];
    if (firstTier) {
      empty.textContent = 'Add ' + firstTier.units +
        ' items to start saving up to ' + firstTier.percent + '% off.';
    }
    selected.hidden = totals.totalUnits === 0;
    visualWrap.hidden = totals.totalUnits === 0;
    visualCount.textContent = totals.totalUnits + ' ' +
      (totals.totalUnits === 1 ? 'item' : 'items');
    this.renderDiscountProgress(summary, totals);
    summary.querySelector('[data-kit-unit-count]').textContent =
      totals.totalUnits + ' of ' + this.config.limits.maxUnitsPerKit;
    subtotal.value = String(totals.subtotal);
    subtotal.textContent = this.formatMoney(totals.subtotal, this.currencyCode);
    savings.value = String(totals.savings);
    savings.textContent = '−' + this.formatMoney(totals.savings, this.currencyCode);
    if (safePercent) {
      safePercent.value = String(totals.safePercent);
      safePercent.textContent = totals.safePercent + '%';
    }
    total.value = String(totals.total);
    total.textContent = this.formatMoney(totals.total, this.currencyCode);
    if (actionTotal) {
      actionTotal.value = String(totals.total);
      actionTotal.textContent = this.formatMoney(totals.total, this.currencyCode);
    }
    var minimumItems = this.config.tiers[0]
      ? this.config.tiers[0].units
      : 4;
    submit.disabled = !this.config.enabled ||
      totals.tierUnitCount < minimumItems ||
      totals.safePercent <= 0 ||
      this.config.previewMode ||
      this.isSubmitting ||
      this.cartAddUncertain;
    if (this.config.previewMode && submitLabel) {
      submitLabel.textContent = 'Preview Only — Checkout Disabled';
    }
  };

  KitBuilder.prototype.createSummaryLine = function (line) {
    var item = document.createElement('li');
    item.className = 'kit-builder__line';

    var image = document.createElement('img');
    image.className = 'kit-builder__line-image';
    image.alt = '';
    image.loading = 'lazy';
    image.width = line.image ? line.image.width : 200;
    image.height = line.image ? line.image.height : 200;
    if (line.image) {
      applyResponsiveImage(image, line.image, '48px', [96, 144]);
    }
    item.appendChild(image);

    var copy = document.createElement('div');
    copy.className = 'kit-builder__line-copy';
    var title = document.createElement('span');
    title.className = 'kit-builder__line-title';
    title.textContent = line.title;
    var variant = document.createElement('span');
    variant.className = 'kit-builder__line-variant';
    variant.textContent = line.variantTitle + ' · ' + this.formatMoney(line.price.amount, line.price.currencyCode);
    var rule = document.createElement('span');
    rule.className = 'kit-builder__line-rule';
    if (line.tierRole === 'addon') {
      rule.textContent = 'Add-on · discount applies, no savings progress';
    } else {
      rule.textContent = 'Moves your savings progress';
    }
    copy.appendChild(title);
    copy.appendChild(variant);
    copy.appendChild(rule);
    item.appendChild(copy);

    var controls = document.createElement('div');
    controls.className = 'kit-builder__line-controls';
    var quantity = document.createElement('div');
    quantity.className = 'kit-builder__line-quantity';
    quantity.setAttribute('role', 'group');
    quantity.setAttribute('aria-label', 'Quantity for ' + line.title);
    quantity.appendChild(this.createLineButton(
      'decrement',
      line.variantId,
      'Decrease quantity for ' + line.title,
      '−'
    ));
    var output = document.createElement('output');
    output.setAttribute('aria-label', 'Quantity');
    output.textContent = line.quantity;
    quantity.appendChild(output);
    var increase = this.createLineButton(
      'increment',
      line.variantId,
      'Increase quantity for ' + line.title,
      '+'
    );
    increase.disabled = this.productQuantity(line.productId) >= this.config.limits.maxPerProduct ||
      this.familyQuantity(line.familyKey) >= this.config.limits.maxPerFamily ||
      this.totalUnits() >= this.config.limits.maxUnitsPerKit;
    quantity.appendChild(increase);
    controls.appendChild(quantity);

    var remove = this.createLineButton('remove', line.variantId, 'Remove ' + line.title, 'Remove');
    remove.className = 'kit-builder__line-remove';
    controls.appendChild(remove);
    item.appendChild(controls);
    return item;
  };

  KitBuilder.prototype.createLineButton = function (action, variantId, label, text) {
    var button = document.createElement('button');
    button.type = 'button';
    button.dataset.kitLineAction = action;
    button.dataset.variantId = variantId;
    button.setAttribute('aria-label', label);
    button.textContent = text;
    return button;
  };

  KitBuilder.prototype.createVisualItem = function (line) {
    var item = document.createElement('li');
    item.className = 'kit-builder__visual-item';

    var remove = this.createLineButton(
      'decrement',
      line.variantId,
      'Remove one ' + line.title + ' from your kit',
      ''
    );
    remove.className = 'kit-builder__visual-remove';
    remove.dataset.kitLineSource = 'visual';
    remove.disabled = this.isSubmitting || this.cartAddUncertain;

    if (line.image) {
      var image = document.createElement('img');
      image.alt = '';
      image.loading = 'lazy';
      applyResponsiveImage(image, line.image, '72px', [96, 144, 192]);
      remove.appendChild(image);
    } else {
      var fallback = document.createElement('span');
      fallback.className = 'kit-builder__visual-fallback';
      fallback.setAttribute('aria-hidden', 'true');
      fallback.textContent = String(line.title || 'Item').charAt(0);
      remove.appendChild(fallback);
    }

    var cue = document.createElement('span');
    cue.className = 'kit-builder__visual-remove-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.textContent = '×';
    remove.appendChild(cue);

    if (line.quantity > 1) {
      var quantity = document.createElement('span');
      quantity.className = 'kit-builder__visual-quantity';
      quantity.setAttribute('aria-hidden', 'true');
      quantity.textContent = '×' + line.quantity;
      remove.appendChild(quantity);
    }

    item.appendChild(remove);
    return item;
  };

  KitBuilder.prototype.renderTierList = function (itemCount, safePercent) {
    var earnedTier = activeTier(this.config.tiers, itemCount);
    var tiers = this.config.tiers;
    this.root.querySelectorAll('[data-kit-tier-list]').forEach(function (list) {
      var fragment = document.createDocumentFragment();

      tiers.forEach(function (entry, index) {
        var item = document.createElement('li');
        var count = document.createElement('span');
        var countValue = document.createElement('strong');
        var countLabel = document.createElement('span');
        var saving = document.createElement('span');
        var isEarned = itemCount >= entry.units;
        var isActive = isEarned && entry.percent === safePercent && safePercent > 0;

        count.className = 'kit-builder__tier-count';
        countValue.textContent = String(entry.units) + (index === tiers.length - 1 ? '+' : '');
        countLabel.className = 'kit-builder__tier-label';
        countLabel.textContent = 'items';
        count.appendChild(countValue);
        count.appendChild(countLabel);
        saving.className = 'kit-builder__tier-saving';
        saving.textContent = 'Up to ' + entry.percent + '% off';
        item.classList.toggle('is-earned', isEarned);
        item.classList.toggle('is-active', isActive);
        if (isActive) item.setAttribute('aria-current', 'true');
        if (isEarned && entry.percent > safePercent && entry.percent <= earnedTier.percent) {
          item.setAttribute('aria-label', 'At ' + entry.units +
            ' items, this tier offers up to ' + entry.percent +
            ' percent; the current estimated discount is ' + safePercent + ' percent');
        }
        item.appendChild(count);
        item.appendChild(saving);
        fragment.appendChild(item);
      });

      list.replaceChildren(fragment);
    }, this);
  };

  KitBuilder.prototype.persistStaged = function () {
    safeStorageSet(this.storageKey, JSON.stringify(Array.from(this.staged.values())));
  };

  KitBuilder.prototype.applyApprovalVersion = function (value) {
    var nextVersion = String(value || '');
    if (!nextVersion || nextVersion === this.config.approvalVersion) return;

    var previousStorageKey = this.storageKey;
    this.config.approvalVersion = nextVersion;
    this.storageKey = this.storagePrefix + nextVersion;
    this.staged.clear();
    safeStorageRemove(previousStorageKey);
    this.restoreStaged();
    this.renderSummary();
  };

  KitBuilder.prototype.restoreStaged = function () {
    var raw = safeStorageGet(this.storageKey);
    if (!raw) return;

    try {
      var entries = JSON.parse(raw);
      var self = this;
      if (!Array.isArray(entries)) return;

      entries.forEach(function (entry) {
        var item = normalizeItem(entry);
        var quantity = Math.min(
          remainingItemCapacity(
            Array.from(self.staged.values()),
            item,
            self.config.limits
          ),
          Math.max(1, toNumber(entry.quantity, 1))
        );
        item.quantity = quantity;
        if (
          quantity > 0 &&
          item.available &&
          item.variantId &&
          item.productId &&
          self.totalUnits() + quantity <= self.config.limits.maxUnitsPerKit
        ) {
          self.staged.set(item.variantId, item);
        }
      });
    } catch (error) {
      safeStorageRemove(this.storageKey);
    }
  };

  KitBuilder.prototype.restorePendingAdd = function () {
    var raw = safeStorageGet(PENDING_ADD_KEY);
    if (!raw) return;

    try {
      var pending = JSON.parse(raw);
      if (
        !pending ||
        typeof pending.kitId !== 'string' ||
        !pending.kitId ||
        !Array.isArray(pending.items) ||
        !pending.items.length
      ) {
        safeStorageRemove(PENDING_ADD_KEY);
        return;
      }

      this.pendingAdd = pending;
      this.cartAddUncertain = true;
    } catch (error) {
      safeStorageRemove(PENDING_ADD_KEY);
    }
  };

  KitBuilder.prototype.persistPendingAdd = function (kitId, items) {
    this.pendingAdd = {
      kitId: kitId,
      approvalVersion: this.config.approvalVersion,
      createdAt: Date.now(),
      items: items.map(function (item) {
        return {
          id: String(item.id),
          quantity: item.quantity
        };
      })
    };
    safeStorageSet(PENDING_ADD_KEY, JSON.stringify(this.pendingAdd));
  };

  KitBuilder.prototype.clearPendingAdd = function () {
    if (this.pendingReconcileTimer) {
      window.clearTimeout(this.pendingReconcileTimer);
      this.pendingReconcileTimer = null;
    }
    this.pendingAdd = null;
    this.cartAddUncertain = false;
    safeStorageRemove(PENDING_ADD_KEY);
    this.setPendingSelectionState(false);
  };

  KitBuilder.prototype.inspectPendingKitInCart = async function () {
    if (!this.pendingAdd) return { status: 'absent' };

    var result = await fetchJsonWithTimeout('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }, 'The cart check took too long.');

    if (!result.response.ok || !result.payload || !Array.isArray(result.payload.items)) {
      return { status: 'unavailable' };
    }

    var quantities = new Map();
    var matchingLineCount = 0;
    result.payload.items.forEach(function (line) {
      var properties = line && line.properties;
      if (!properties || properties._dux_kit_id !== this.pendingAdd.kitId) return;
      matchingLineCount += 1;
      var variantId = String(line.variant_id || line.id || '');
      quantities.set(variantId, (quantities.get(variantId) || 0) + toNumber(line.quantity, 0));
    }, this);

    if (matchingLineCount === 0) return { status: 'absent' };

    var complete = this.pendingAdd.items.every(function (item) {
      return (quantities.get(String(item.id)) || 0) >= item.quantity;
    });
    return { status: complete ? 'confirmed' : 'partial' };
  };

  KitBuilder.prototype.pollForPendingKit = async function () {
    var observedStatus = 'unavailable';
    for (var attempt = 0; attempt < CART_CONFIRMATION_ATTEMPTS; attempt += 1) {
      if (attempt > 0) await wait(CART_CONFIRMATION_DELAY);
      try {
        var result = await this.inspectPendingKitInCart();
        if (result.status === 'confirmed' || result.status === 'partial') {
          return result;
        }
        if (result.status === 'absent') observedStatus = 'absent';
      } catch (error) {
        // Keep checking. A transient cart read must never trigger a duplicate add.
      }
    }
    return { status: observedStatus };
  };

  KitBuilder.prototype.reconcilePendingAdd = async function () {
    if (!this.pendingAdd) return;

    this.setPendingSelectionState(true);
    this.setSubmitStatus('Confirming a previous kit add before another can be submitted…', false);
    var reconciliation = await this.pollForPendingKit();
    if (reconciliation.status !== 'confirmed') {
      var createdAt = toNumber(this.pendingAdd.createdAt, Date.now());
      var remaining = PENDING_ADD_MAX_AGE - (Date.now() - createdAt);
      if (remaining <= 0 && !this.activeCartAddPending) {
        var resolution = expiredPendingResolution(reconciliation.status);
        this.clearPendingAdd();
        if (resolution.clearSelections) {
          this.staged.clear();
          safeStorageRemove(this.storageKey);
          this.refreshVisibleCards();
        }
        this.renderSummary();
        this.setSubmitStatus(resolution.message, reconciliation.status !== 'absent');
        this.announce(resolution.message);
        if (reconciliation.status === 'partial') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
        return;
      }

      var pendingMessage = reconciliation.status === 'partial'
        ? 'Part of this kit is visible in your cart. Check the cart before making changes; this page will keep checking.'
        : reconciliation.status === 'unavailable'
          ? 'The cart could not be verified. This page will keep checking and will not submit a duplicate kit.'
          : 'A previous kit add is still being confirmed. Check your cart; this page will keep checking automatically.';
      this.setSubmitStatus(pendingMessage, true);
      this.announce(pendingMessage);
      if (this.pendingReconcileTimer) window.clearTimeout(this.pendingReconcileTimer);
      this.pendingReconcileTimer = window.setTimeout(
        this.reconcilePendingAdd.bind(this),
        pendingRecheckDelay(remaining)
      );
      return;
    }
    this.clearPendingAdd();
    this.staged.clear();
    safeStorageRemove(this.storageKey);
    this.renderSummary();
    this.refreshVisibleCards();
    this.setSubmitStatus('Kit added. Your cart is ready to review.', false);
    this.announce('Your complete kit is in the cart.');
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  };

  KitBuilder.prototype.reconcileLoadedVariants = function () {
    var self = this;
    var loaded = new Map();
    this.products.forEach(function (product) {
      product.variants.forEach(function (variant) {
        loaded.set(variant.variantId, variant);
      });
    });

    loaded.forEach(function (variant, variantId) {
      var staged = self.staged.get(variantId);
      if (!staged) return;
      if (!variant.available) {
        self.staged.delete(variantId);
        self.announce(variant.title + ' is no longer available and was removed from your kit.');
      } else {
        self.staged.set(variantId, Object.assign({}, variant, { quantity: staged.quantity }));
      }
    });
    this.persistStaged();
    this.renderSummary();
  };

  KitBuilder.prototype.submitKit = async function () {
    if (!this.config.enabled) {
      this.setSubmitStatus('The kit builder is temporarily unavailable.', true);
      return;
    }
    if (this.config.previewMode) {
      this.setSubmitStatus('Preview mode is active. Checkout remains disabled.', false);
      return;
    }
    if (this.isSubmitting || this.cartAddUncertain || this.staged.size === 0) return;
    var self = this;
    var approvalVersion = this.config.approvalVersion;
    var minimumItems = this.config.tiers[0]
      ? this.config.tiers[0].units
      : 4;

    if (!approvalVersion) {
      this.setSubmitStatus('This kit catalog is missing a version. Refresh the page before adding the kit.', true);
      return;
    }
    var evaluation = this.savingsEvaluation();
    var itemCount = evaluation.tierUnitCount;
    if (itemCount < minimumItems) {
      this.setSubmitStatus(
        'Add ' + (minimumItems - itemCount) + ' more ' +
          (minimumItems - itemCount === 1 ? 'item' : 'items') +
          ' to complete this kit.',
        true
      );
      return;
    }
    if (evaluation.percent <= 0) {
      this.setSubmitStatus(
        'This kit cannot receive a discount yet. Add another item or choose a higher-value item.',
        true
      );
      return;
    }

    var unavailable = Array.from(this.staged.values()).find(function (line) {
      return !line.available;
    });
    if (unavailable) {
      this.setSubmitStatus(unavailable.title + ' is no longer available. Remove it and try again.', true);
      return;
    }

    var stagedSnapshot = Array.from(this.staged.values()).map(function (line) {
      return Object.assign({}, line, {
        price: Object.assign({}, line.price)
      });
    });
    var snapshotByVariant = new Map(stagedSnapshot.map(function (line) {
      return [line.variantId, line];
    }));

    this.isSubmitting = true;
    this.setSubmittingState(true);
    this.setSubmitStatus('Checking current availability and kit pricing…', false);
    this.announce('Checking current availability and kit pricing.');

    try {
      var preflightResult = await fetchJsonWithTimeout(this.preflightPath, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          approvalVersion: approvalVersion,
          rulesVersion: this.config.rulesVersion,
          lines: stagedSnapshot.map(function (line) {
            return {
              variantId: line.variantId,
              quantity: line.quantity
            };
          })
        })
      }, 'The kit check took too long. Try again.');
      if (!this.config.enabled) {
        var disabledDuringPreflight = new Error(
          'The kit builder is temporarily unavailable.'
        );
        disabledDuringPreflight.isPreflight = true;
        disabledDuringPreflight.code = 'BUILDER_DISABLED';
        throw disabledDuringPreflight;
      }
      var preflightResponse = preflightResult.response;
      var preflightPayload = preflightResult.payload;
      if (!preflightResponse.ok) {
        this.handlePreflightFailure(preflightPayload);
        var preflightError = new Error(this.preflightErrorMessage(preflightPayload));
        preflightError.isPreflight = true;
        preflightError.code = preflightPayload.error;
        throw preflightError;
      }

      var canonicalLines = this.validatePreflightPayload(
        preflightPayload,
        snapshotByVariant
      );
      var kitId = createApprovalBoundKitId(preflightPayload.approvalVersion);
      var items = canonicalLines.map(function (line) {
        return {
          id: numericId(line.variantId),
          quantity: line.quantity,
          properties: {
            _dux_kit_id: kitId,
            _dux_kit_version: preflightPayload.approvalVersion,
            _dux_kit_brand: line.brand,
            _dux_kit_category: line.category,
            _dux_kit_source: SOURCE
          }
        };
      });
      this.persistPendingAdd(kitId, items);

      this.setSubmitStatus('Adding your complete kit…', false);
      this.track('kit_submitted', {
        kit_id: kitId,
        approval_version: preflightPayload.approvalVersion,
        distinct_products: preflightPayload.distinctProducts,
        tier_units: preflightPayload.tierUnitCount,
        qualifying_picks: preflightPayload.tierUnitCount,
        total_units: preflightPayload.totalUnits,
        discount_percent: preflightPayload.discountPercent,
        estimated_subtotal: this.subtotal()
      });

      this.activeCartAddPending = true;
      var cartAddPromise = fetchJsonWithTimeout('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      }, 'Shopify is still confirming the kit.').then(function (result) {
        self.activeCartAddPending = false;
        return result;
      }).catch(function (error) {
        self.activeCartAddPending = false;
        error.isCartTransport = true;
        throw error;
      });
      var cartAddResult;
      try {
        cartAddResult = await raceWithTimeout(
          cartAddPromise,
          'Shopify is still confirming the kit.'
        );
      } catch (error) {
        this.cartAddUncertain = true;
        this.setSubmitStatus('Shopify is still confirming your cart. Checking before allowing a retry…', false);
        if (error.isCartTransport) {
          var transportReconciliation = await this.pollForPendingKit();
          if (transportReconciliation.status !== 'confirmed') {
            var transportUncertainError = new Error(
              'The cart update is still unconfirmed. Check your cart before trying again.'
            );
            transportUncertainError.code = 'CART_ADD_UNCERTAIN';
            throw transportUncertainError;
          }
          cartAddResult = { response: { ok: true }, payload: {} };
        } else if (error.code !== 'REQUEST_TIMEOUT') {
          throw error;
        }

        if (!cartAddResult) {
          var confirmation = await Promise.race([
            cartAddPromise.then(function (result) {
              return { type: 'response', result: result };
            }).catch(function (requestError) {
              return { type: 'error', error: requestError };
            }),
            this.pollForPendingKit().then(function (result) {
              return { type: result.status };
            })
          ]);

          if (confirmation.type === 'error') {
            var lateTransportReconciliation = await this.pollForPendingKit();
            if (lateTransportReconciliation.status !== 'confirmed') {
              var lateTransportUncertainError = new Error(
                'The cart update is still unconfirmed. Check your cart before trying again.'
              );
              lateTransportUncertainError.code = 'CART_ADD_UNCERTAIN';
              throw lateTransportUncertainError;
            }
            cartAddResult = { response: { ok: true }, payload: {} };
          } else if (confirmation.type !== 'confirmed' && confirmation.type !== 'response') {
            var uncertainError = new Error(
              'The cart update is still unconfirmed. Check your cart before trying again.'
            );
            uncertainError.code = 'CART_ADD_UNCERTAIN';
            throw uncertainError;
          } else {
            cartAddResult = confirmation.type === 'response'
              ? confirmation.result
              : { response: { ok: true }, payload: {} };
          }
        }
      }

      var response = cartAddResult.response;
      var payload = cartAddResult.payload;
      if (!response.ok) {
        this.clearPendingAdd();
        throw new Error(payload.description || payload.message || 'Shopify could not add the kit.');
      }

      var successfulAddAnalytics = {
        kit_id: kitId,
        approval_version: preflightPayload.approvalVersion,
        distinct_products: preflightPayload.distinctProducts,
        tier_units: preflightPayload.tierUnitCount,
        qualifying_picks: preflightPayload.tierUnitCount,
        total_units: preflightPayload.totalUnits,
        discount_percent: preflightPayload.discountPercent,
        estimated_subtotal: this.subtotal()
      };

      this.staged.clear();
      safeStorageRemove(this.storageKey);
      this.clearPendingAdd();
      this.renderSummary();
      this.refreshVisibleCards();
      this.setSubmitStatus('Kit added. Your cart is ready to review.', false);
      this.announce('Your complete kit was added to the cart.');
      this.track('kit_cart_added', successfulAddAnalytics);

      try {
        if (payload.sections && payload.sections['cart-icon-bubble']) {
          var cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble) cartBubble.innerHTML = payload.sections['cart-icon-bubble'];
        }
        this.closeSummary();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        window.setTimeout(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            detail: { opener: self.elements.openSummary }
          }));
        }, 180);
      } catch (followUpError) {
        // The cart mutation succeeded. Optional drawer/UI follow-up must never create a retry path.
      }
    } catch (error) {
      if (error.isPreflight && error.code === 'BUILDER_DISABLED') {
        return;
      }
      if (error.code !== 'CART_ADD_UNCERTAIN' && this.pendingAdd) {
        this.clearPendingAdd();
      }
      if (error.code === 'CART_ADD_UNCERTAIN' && this.pendingAdd) {
        this.setPendingSelectionState(true);
        if (this.pendingReconcileTimer) window.clearTimeout(this.pendingReconcileTimer);
        this.pendingReconcileTimer = window.setTimeout(
          this.reconcilePendingAdd.bind(this),
          PENDING_RECHECK_DELAY
        );
      }
      var selectionsMessage = error.isPreflight &&
        error.code === 'APPROVAL_VERSION_STALE'
        ? ''
        : ' Your selections are still saved.';
      this.setSubmitStatus(
        (error.message || 'The kit could not be added.') + selectionsMessage,
        true
      );
      this.announce(this.submitStatusText());
    } finally {
      this.isSubmitting = false;
      this.setSubmittingState(false);
    }
  };

  KitBuilder.prototype.validatePreflightPayload = function (payload, snapshotByVariant) {
    var self = this;
    var snapshotLines = Array.from(snapshotByVariant.values());
    var expectedUnits = snapshotLines.reduce(function (total, line) {
      return total + line.quantity;
    }, 0);
    var expectedProducts = new Set(snapshotLines.map(function (line) {
      return line.productId;
    })).size;
    var expectedEvaluation = marginalSafePercent(
      snapshotLines,
      this.config.tiers,
      this.config.limits,
      this.config.marginalGuard
    );
    if (
      !payload ||
      payload.ok !== true ||
      payload.approvalVersion !== this.config.approvalVersion ||
      Number(payload.rulesVersion) !== this.config.rulesVersion ||
      !Array.isArray(payload.lines) ||
      payload.lines.length !== snapshotByVariant.size ||
      Number(payload.totalUnits) !== expectedUnits ||
      Number(payload.distinctProducts) !== expectedProducts ||
      Number(payload.tierUnitCount) !== expectedEvaluation.tierUnitCount ||
      Number(payload.candidateDiscountPercent) !== expectedEvaluation.earnedPercent ||
      Number(payload.safeDiscountPercent) !== expectedEvaluation.percent ||
      !Number.isFinite(Number(payload.discountPercent)) ||
      Number(payload.discountPercent) !== expectedEvaluation.percent
    ) {
      var invalidResponse = new Error(
        'The kit could not be verified. Refresh the page before trying again.'
      );
      invalidResponse.isPreflight = true;
      invalidResponse.code = 'INVALID_PREFLIGHT_RESPONSE';
      throw invalidResponse;
    }

    var seen = new Set();
    var priceChanged = false;
    var canonicalUpdates = [];
    payload.lines.forEach(function (line) {
      var staged = line && snapshotByVariant.get(line.variantId);
      var quantity = line && Number(line.quantity);
      var rawAmount = line && line.price && Number(line.price.amount);
      var rawCurrency = line && line.price && String(line.price.currencyCode || '');
      if (
        !staged ||
        seen.has(line.variantId) ||
        !Number.isInteger(quantity) ||
        quantity !== staged.quantity ||
        !numericId(line.variantId) ||
        line.productId !== staged.productId ||
        line.familyKey !== staged.familyKey ||
        line.familyLabel !== staged.familyLabel ||
        line.slotKey !== staged.slotKey ||
        line.tierRole !== staged.tierRole ||
        !['dux', 'bux', 'shared'].includes(line.brand) ||
        typeof line.category !== 'string' ||
        !line.category.trim() ||
        typeof line.title !== 'string' ||
        typeof line.variantTitle !== 'string' ||
        !Number.isFinite(rawAmount) ||
        rawAmount < 0 ||
        !rawCurrency
      ) {
        var invalidLine = new Error(
          'The kit catalog changed. Refresh the page before trying again.'
        );
        invalidLine.isPreflight = true;
        invalidLine.code = 'INVALID_PREFLIGHT_RESPONSE';
        throw invalidLine;
      }
      seen.add(line.variantId);

      var canonicalPrice = normalizePrice(line.price, rawCurrency);
      if (
        toNumber(staged.price.amount, 0) !== canonicalPrice.amount ||
        staged.price.currencyCode !== canonicalPrice.currencyCode
      ) {
        priceChanged = true;
      }

      var current = self.staged.get(line.variantId);
      if (!current) {
        var missingLine = new Error(
          'The staged kit changed while it was being verified. Review it and try again.'
        );
        missingLine.isPreflight = true;
        missingLine.code = 'INVALID_PREFLIGHT_RESPONSE';
        throw missingLine;
      }
      canonicalUpdates.push({
        variantId: line.variantId,
        value: Object.assign({}, current, {
          productId: line.productId,
          brand: line.brand,
          category: line.category,
          familyKey: line.familyKey,
          familyLabel: line.familyLabel,
          slotKey: line.slotKey,
          tierRole: line.tierRole,
          title: line.title,
          variantTitle: line.variantTitle,
          price: canonicalPrice,
          quantity: quantity
        })
      });
    });

    canonicalUpdates.forEach(function (update) {
      self.staged.set(update.variantId, update.value);
    });
    this.persistStaged();

    if (priceChanged) {
      this.renderSummary();
      this.refreshVisibleCards();
      this.reloadCatalog();
      var priceError = new Error(
        'A product price changed. Review the updated total, then add the kit again.'
      );
      priceError.isPreflight = true;
      priceError.code = 'PRICE_CHANGED';
      throw priceError;
    }

    return canonicalUpdates.map(function (update) {
      return update.value;
    });
  };

  KitBuilder.prototype.preflightErrorMessage = function (payload) {
    var messages = {
      APPROVAL_VERSION_STALE:
        'The kit catalog changed. Your staged kit was cleared so you can rebuild from the current list.',
      KIT_INCOMPLETE:
        'Add at least four items to complete this kit.',
      KIT_UNIT_LIMIT_EXCEEDED:
        'A kit can contain no more than 12 total units.',
      PRODUCT_LIMIT_EXCEEDED:
        'You have reached the quantity limit for this product.',
      FAMILY_LIMIT_EXCEEDED:
        'You have reached the quantity limit for this product.',
      KIT_VALUE_REQUIREMENT_NOT_MET:
        'This kit cannot receive a discount yet. Add another item or choose a higher-value item.',
      CATALOG_RULES_INVALID:
        'The kit catalog rules could not be verified. Refresh the page and try again.',
      VARIANT_INELIGIBLE:
        'Selected options that are no longer eligible or available were removed.',
      VARIANT_UNAVAILABLE:
        'Selected options that are no longer available were removed.',
      BUILDER_DISABLED:
        'The kit builder is temporarily unavailable.',
      CATALOG_STALE:
        'The kit catalog is refreshing. Try again shortly.',
      CATALOG_UNAVAILABLE:
        'The kit catalog is temporarily unavailable.',
      INVALID_PROXY_SIGNATURE:
        'The kit builder could not securely verify this request.',
      INVALID_REQUEST:
        'The staged kit could not be verified. Refresh the page and try again.',
      PREFLIGHT_UNAVAILABLE:
        'The kit builder could not verify current availability. Try again shortly.'
    };
    return messages[payload && payload.error] ||
      'The kit could not be verified. Try again shortly.';
  };

  KitBuilder.prototype.handlePreflightFailure = function (payload) {
    var code = payload && payload.error;
    var variantIds = payload && Array.isArray(payload.variantIds)
      ? payload.variantIds
      : payload && payload.variantId
        ? [payload.variantId]
        : [];

    if (code === 'BUILDER_DISABLED') {
      this.config.enabled = false;
      this.showDisabled(this.preflightErrorMessage(payload));
      return;
    }

    if (code === 'APPROVAL_VERSION_STALE') {
      var previousStorageKey = this.storageKey;
      var currentVersion = String(payload.currentApprovalVersion || '');
      this.staged.clear();
      safeStorageRemove(previousStorageKey);
      if (currentVersion) {
        this.config.approvalVersion = currentVersion;
        this.storageKey = this.storagePrefix + currentVersion;
        safeStorageRemove(this.storageKey);
      }
      this.renderSummary();
      this.refreshVisibleCards();
      this.reloadCatalog();
      return;
    }

    if (
      (code === 'VARIANT_INELIGIBLE' || code === 'VARIANT_UNAVAILABLE') &&
      variantIds.length
    ) {
      var removed = 0;
      variantIds.forEach(function (variantId) {
        if (this.staged.delete(variantId)) removed += 1;
      }, this);
      if (removed > 0) {
        this.persistStaged();
        this.renderSummary();
        this.refreshVisibleCards();
        this.reloadCatalog();
      }
    }
  };

  KitBuilder.prototype.setPendingSelectionState = function (isPending) {
    if (!this.root) return;

    if (!isPending) {
      this.root.querySelectorAll('[data-kit-pending-disabled]').forEach(function (control) {
        control.disabled = false;
        delete control.dataset.kitPendingDisabled;
      });
      this.refreshVisibleCards();
      return;
    }

    this.root.querySelectorAll(
      '[data-kit-variant-select], [data-kit-add], [data-kit-line-action]'
    ).forEach(function (control) {
      if (!control.disabled) {
        control.disabled = true;
        control.dataset.kitPendingDisabled = 'true';
      }
    });
  };

  KitBuilder.prototype.setSubmittingState = function (isSubmitting) {
    var minimumItems = this.config.tiers[0]
      ? this.config.tiers[0].units
      : 4;
    var evaluation = this.savingsEvaluation();
    this.elements.transactionRegions.forEach(function (region) {
      if (isSubmitting) {
        region.setAttribute('aria-busy', 'true');
      } else {
        region.removeAttribute('aria-busy');
      }
    });
    if (isSubmitting) {
      this.root.querySelectorAll(
        '[data-kit-filters] input, [data-kit-filters] select, ' +
        '[data-kit-filters] button, [data-kit-sort], [data-kit-variant-select], ' +
        '[data-kit-add], [data-kit-line-action], ' +
        '[data-kit-load-more]'
      ).forEach(function (control) {
        if (!control.disabled) {
          control.disabled = true;
          control.dataset.kitTransactionDisabled = 'true';
        }
      });
    } else {
      this.root.querySelectorAll('[data-kit-transaction-disabled]').forEach(function (control) {
        control.disabled = control.dataset.kitSizeUnavailable === 'true';
        delete control.dataset.kitTransactionDisabled;
      });
      if (this.config.enabled) {
        this.updateLoadMore();
        this.refreshVisibleCards();
      }
      this.setPendingSelectionState(this.cartAddUncertain);
    }
    this.root.querySelectorAll('[data-kit-submit]').forEach(function (button) {
      button.classList.toggle('is-loading', isSubmitting);
      button.disabled = !this.config.enabled ||
        isSubmitting ||
        this.config.previewMode ||
        this.cartAddUncertain ||
        evaluation.tierUnitCount < minimumItems ||
        evaluation.percent <= 0;
      button.querySelector('[data-kit-submit-label]').textContent = this.config.previewMode
        ? 'Preview Only — Checkout Disabled'
        : isSubmitting
          ? 'Adding Kit…'
          : 'Add Kit to Cart';
    }, this);
  };

  KitBuilder.prototype.setSubmitStatus = function (message, isError) {
    this.root.querySelectorAll('[data-kit-submit-status]').forEach(function (status) {
      status.textContent = message;
      status.dataset.status = isError ? 'error' : 'info';
    });
  };

  KitBuilder.prototype.submitStatusText = function () {
    var status = this.root.querySelector('[data-kit-submit-status]');
    return status ? status.textContent : '';
  };

  KitBuilder.prototype.loadMoreProducts = async function (focusNewContent) {
    if (
      this.catalogLoading ||
      this.isSubmitting ||
      !this.pageInfo.hasNextPage ||
      !this.pageInfo.endCursor
    ) return null;

    var result = await this.fetchCatalog({ mode: 'append' });
    if (!result) {
      if (focusNewContent) this.focusCatalogResult(result);
      return null;
    }

    this.track('kit_catalog_view_more', {
      added_products: result.addedCount,
      shown_products: this.products.length,
      total_products: this.pageInfo.totalProducts
    });

    if (focusNewContent && result.firstNewCard) {
      this.focusCatalogResult(result);
    }
    return result;
  };

  KitBuilder.prototype.updateLoadMore = function () {
    if (
      !this.elements.loadMoreWrap ||
      !this.elements.loadMore ||
      !this.elements.loadMoreLabel ||
      !this.elements.loadMoreCount
    ) return;

    var count = this.products.length;
    var total = this.pageInfo.totalProducts;
    var hasNext = this.pageInfo.hasNextPage === true && Boolean(this.pageInfo.endCursor);
    if (count === 0 || (!hasNext && !this.hasLoadedMore)) {
      this.elements.loadMoreWrap.hidden = true;
      return;
    }

    this.elements.loadMoreWrap.hidden = false;
    this.elements.loadMoreCount.textContent = total !== null
      ? 'Showing ' + count + ' of ' + total + ' kit products'
      : (hasNext
          ? count + ' kit products shown'
          : 'All ' + count + ' kit products shown');

    if (this.catalogLoading) {
      this.elements.loadMore.disabled = true;
      this.elements.loadMoreLabel.textContent = 'Loading…';
      return;
    }

    if (!hasNext) {
      this.elements.loadMore.disabled = true;
      this.elements.loadMoreLabel.textContent = 'All Products Loaded';
      return;
    }

    var remaining = total === null ? null : Math.max(0, total - count);
    this.elements.loadMore.disabled = this.isSubmitting;
    this.elements.loadMoreLabel.textContent = this.loadMoreFailed
      ? 'Try Again'
      : (remaining === null
          ? 'View More Products'
          : 'View ' + Math.min(this.pageSize, remaining) + ' More Products');
  };

  KitBuilder.prototype.updateFilterCount = function () {
    var values = this.filterValues();
    var count = 0;
    if (values.search) count += 1;
    if (values.brand !== 'all') count += 1;
    if (values.category) count += 1;
    if (values.size) count += 1;
    count += values.colors.length;
    if (values.minPrice) count += 1;
    if (values.maxPrice) count += 1;
    this.elements.filterCount.hidden = count === 0;
    this.elements.filterCount.textContent = count;
  };

  KitBuilder.prototype.formatMoney = function (amount, currencyCode) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode || this.currencyCode || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + toNumber(amount, 0).toFixed(2);
    }
  };

  KitBuilder.prototype.announce = function (message) {
    var announcer = this.elements.announcer;
    announcer.textContent = '';
    window.setTimeout(function () {
      announcer.textContent = message;
    }, 30);
  };

  KitBuilder.prototype.track = function (eventName, payload) {
    try {
      if (window.DUXBUX && typeof window.DUXBUX.track === 'function') {
        window.DUXBUX.track(eventName, payload || {});
      }
    } catch (error) {
      // Analytics must never interrupt merchandising or cart behavior.
    }
  };

  function initializeKitBuilders(scope) {
    (scope || document).querySelectorAll('[data-kit-builder]:not([data-kit-initialized])').forEach(function (root) {
      root.dataset.kitInitialized = 'true';
      new KitBuilder(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeKitBuilders(document);
    });
  } else {
    initializeKitBuilders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeKitBuilders(event.target);
  });

  window.DUXBUXKitBuilderUtils = {
    activeTier: activeTier,
    nextTier: nextTier,
    groupItemsByProduct: groupItemsByProduct,
    productPriceCandidates: productPriceCandidates,
    updateKnownCategories: updateKnownCategories,
    normalizeSizeFacets: normalizeSizeFacets,
    groupSizeFacets: groupSizeFacets,
    canonicalSizeValue: canonicalSizeValue,
    variantMatchesSize: variantMatchesSize,
    normalizeColorFamilies: normalizeColorFamilies,
    normalizeColorFacets: normalizeColorFacets,
    variantMatchesColors: variantMatchesColors,
    variantMatchesPrice: variantMatchesPrice,
    matchingCardVariants: matchingCardVariants,
    unambiguousVariantForFilters: unambiguousVariantForFilters,
    unambiguousVariantForSize: unambiguousVariantForSize,
    normalizeItem: normalizeItem,
    tierUnitCount: tierUnitCount,
    marginalSafePercent: marginalSafePercent,
    familyUnitCount: familyUnitCount,
    productUnitCount: productUnitCount,
    remainingItemCapacity: remainingItemCapacity,
    normalizeLimits: normalizeLimitValues,
    discountedTotalCents: discountedTotalCents,
    catalogPayloadIsValid: catalogPayloadIsValid,
    normalizeSearchValue: normalizeSearchValue,
    createApprovalBoundKitId: createApprovalBoundKitId,
    pendingRecheckDelay: pendingRecheckDelay,
    expiredPendingResolution: expiredPendingResolution,
    focusElement: focusElement,
    categoryOrder: CATEGORY_ORDER.slice()
  };
}());
